export const FipsList = [
    {
        "fips": 1001,
        "countyname": "Autauga County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1003,
        "countyname": "Baldwin County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1005,
        "countyname": "Barbour County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1007,
        "countyname": "Bibb County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1009,
        "countyname": "Blount County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1011,
        "countyname": "Bullock County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1013,
        "countyname": "Butler County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1015,
        "countyname": "Calhoun County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1017,
        "countyname": "Chambers County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1019,
        "countyname": "Cherokee County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1021,
        "countyname": "Chilton County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1023,
        "countyname": "Choctaw County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1025,
        "countyname": "Clarke County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1027,
        "countyname": "Clay County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1029,
        "countyname": "Cleburne County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1031,
        "countyname": "Coffee County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1033,
        "countyname": "Colbert County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1035,
        "countyname": "Conecuh County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1037,
        "countyname": "Coosa County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1039,
        "countyname": "Covington County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1041,
        "countyname": "Crenshaw County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1043,
        "countyname": "Cullman County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1045,
        "countyname": "Dale County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1047,
        "countyname": "Dallas County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1049,
        "countyname": "DeKalb County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1051,
        "countyname": "Elmore County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1053,
        "countyname": "Escambia County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1055,
        "countyname": "Etowah County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1057,
        "countyname": "Fayette County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1059,
        "countyname": "Franklin County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1061,
        "countyname": "Geneva County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1063,
        "countyname": "Greene County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1065,
        "countyname": "Hale County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1067,
        "countyname": "Henry County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1069,
        "countyname": "Houston County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1071,
        "countyname": "Jackson County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1073,
        "countyname": "Jefferson County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1075,
        "countyname": "Lamar County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1077,
        "countyname": "Lauderdale County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1079,
        "countyname": "Lawrence County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1081,
        "countyname": "Lee County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1083,
        "countyname": "Limestone County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1085,
        "countyname": "Lowndes County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1087,
        "countyname": "Macon County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1089,
        "countyname": "Madison County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1091,
        "countyname": "Marengo County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1093,
        "countyname": "Marion County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1095,
        "countyname": "Marshall County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1097,
        "countyname": "Mobile County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1099,
        "countyname": "Monroe County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1101,
        "countyname": "Montgomery County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1103,
        "countyname": "Morgan County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1105,
        "countyname": "Perry County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1107,
        "countyname": "Pickens County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1109,
        "countyname": "Pike County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1111,
        "countyname": "Randolph County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1113,
        "countyname": "Russell County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1115,
        "countyname": "St. Clair County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1117,
        "countyname": "Shelby County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1119,
        "countyname": "Sumter County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1121,
        "countyname": "Talladega County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1123,
        "countyname": "Tallapoosa County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1125,
        "countyname": "Tuscaloosa County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1127,
        "countyname": "Walker County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1129,
        "countyname": "Washington County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1131,
        "countyname": "Wilcox County",
        "stateorprovince": "AL"
    },
    {
        "fips": 1133,
        "countyname": "Winston County",
        "stateorprovince": "AL"
    },
    {
        "fips": 2013,
        "countyname": "Aleutians East Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2016,
        "countyname": "Aleutians West Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 2020,
        "countyname": "Anchorage Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2050,
        "countyname": "Bethel Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 2060,
        "countyname": "Bristol Bay Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2070,
        "countyname": "Dillingham Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 2090,
        "countyname": "Fairbanks North Star Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2100,
        "countyname": "Haines Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2110,
        "countyname": "Juneau Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2122,
        "countyname": "Kenai Peninsula Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2130,
        "countyname": "Ketchikan Gateway Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2150,
        "countyname": "Kodiak Island Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2164,
        "countyname": "Lake and Peninsula Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2170,
        "countyname": "Matanuska-Susitna Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2180,
        "countyname": "Nome Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 2185,
        "countyname": "North Slope Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2188,
        "countyname": "Northwest Arctic Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2201,
        "countyname": "Prince of Wales-Outer Ketchikan Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 2220,
        "countyname": "Sitka Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 2232,
        "countyname": "Skagway/Hoonah/Angoon Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 2240,
        "countyname": "Southeast Fairbanks Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 2261,
        "countyname": "Valdez-Cordova Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 2270,
        "countyname": "Wade Hampton Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 2280,
        "countyname": "Wrangell-Petersburg Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 2282,
        "countyname": "Yakutat",
        "stateorprovince": "AK"
    },
    {
        "fips": 2290,
        "countyname": "Yukon-Koyukuk Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 4001,
        "countyname": "Apache County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4003,
        "countyname": "Cochise County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4005,
        "countyname": "Coconino County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4007,
        "countyname": "Gila County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4009,
        "countyname": "Graham County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4011,
        "countyname": "Greenlee County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4012,
        "countyname": "La Paz County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4013,
        "countyname": "Maricopa County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4015,
        "countyname": "Mohave County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4017,
        "countyname": "Navajo County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4019,
        "countyname": "Pima County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4021,
        "countyname": "Pinal County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4023,
        "countyname": "Santa Cruz County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4025,
        "countyname": "Yavapai County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 4027,
        "countyname": "Yuma County",
        "stateorprovince": "AZ"
    },
    {
        "fips": 5001,
        "countyname": "Arkansas County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5003,
        "countyname": "Ashley County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5005,
        "countyname": "Baxter County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5007,
        "countyname": "Benton County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5009,
        "countyname": "Boone County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5011,
        "countyname": "Bradley County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5013,
        "countyname": "Calhoun County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5015,
        "countyname": "Carroll County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5017,
        "countyname": "Chicot County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5019,
        "countyname": "Clark County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5021,
        "countyname": "Clay County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5023,
        "countyname": "Cleburne County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5025,
        "countyname": "Cleveland County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5027,
        "countyname": "Columbia County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5029,
        "countyname": "Conway County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5031,
        "countyname": "Craighead County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5033,
        "countyname": "Crawford County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5035,
        "countyname": "Crittenden County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5037,
        "countyname": "Cross County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5039,
        "countyname": "Dallas County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5041,
        "countyname": "Desha County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5043,
        "countyname": "Drew County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5045,
        "countyname": "Faulkner County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5047,
        "countyname": "Franklin County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5049,
        "countyname": "Fulton County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5051,
        "countyname": "Garland County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5053,
        "countyname": "Grant County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5055,
        "countyname": "Greene County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5057,
        "countyname": "Hempstead County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5059,
        "countyname": "Hot Spring County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5061,
        "countyname": "Howard County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5063,
        "countyname": "Independence County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5065,
        "countyname": "Izard County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5067,
        "countyname": "Jackson County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5069,
        "countyname": "Jefferson County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5071,
        "countyname": "Johnson County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5073,
        "countyname": "Lafayette County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5075,
        "countyname": "Lawrence County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5077,
        "countyname": "Lee County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5079,
        "countyname": "Lincoln County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5081,
        "countyname": "Little River County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5083,
        "countyname": "Logan County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5085,
        "countyname": "Lonoke County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5087,
        "countyname": "Madison County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5089,
        "countyname": "Marion County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5091,
        "countyname": "Miller County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5093,
        "countyname": "Mississippi County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5095,
        "countyname": "Monroe County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5097,
        "countyname": "Montgomery County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5099,
        "countyname": "Nevada County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5101,
        "countyname": "Newton County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5103,
        "countyname": "Ouachita County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5105,
        "countyname": "Perry County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5107,
        "countyname": "Phillips County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5109,
        "countyname": "Pike County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5111,
        "countyname": "Poinsett County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5113,
        "countyname": "Polk County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5115,
        "countyname": "Pope County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5117,
        "countyname": "Prairie County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5119,
        "countyname": "Pulaski County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5121,
        "countyname": "Randolph County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5123,
        "countyname": "St. Francis County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5125,
        "countyname": "Saline County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5127,
        "countyname": "Scott County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5129,
        "countyname": "Searcy County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5131,
        "countyname": "Sebastian County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5133,
        "countyname": "Sevier County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5135,
        "countyname": "Sharp County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5137,
        "countyname": "Stone County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5139,
        "countyname": "Union County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5141,
        "countyname": "Van Buren County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5143,
        "countyname": "Washington County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5145,
        "countyname": "White County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5147,
        "countyname": "Woodruff County",
        "stateorprovince": "AR"
    },
    {
        "fips": 5149,
        "countyname": "Yell County",
        "stateorprovince": "AR"
    },
    {
        "fips": 6001,
        "countyname": "Alameda County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6003,
        "countyname": "Alpine County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6005,
        "countyname": "Amador County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6007,
        "countyname": "Butte County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6009,
        "countyname": "Calaveras County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6011,
        "countyname": "Colusa County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6013,
        "countyname": "Contra Costa County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6015,
        "countyname": "Del Norte County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6017,
        "countyname": "El Dorado County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6019,
        "countyname": "Fresno County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6021,
        "countyname": "Glenn County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6023,
        "countyname": "Humboldt County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6025,
        "countyname": "Imperial County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6027,
        "countyname": "Inyo County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6029,
        "countyname": "Kern County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6031,
        "countyname": "Kings County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6033,
        "countyname": "Lake County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6035,
        "countyname": "Lassen County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6037,
        "countyname": "Los Angeles County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6039,
        "countyname": "Madera County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6041,
        "countyname": "Marin County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6043,
        "countyname": "Mariposa County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6045,
        "countyname": "Mendocino County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6047,
        "countyname": "Merced County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6049,
        "countyname": "Modoc County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6051,
        "countyname": "Mono County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6053,
        "countyname": "Monterey County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6055,
        "countyname": "Napa County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6057,
        "countyname": "Nevada County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6059,
        "countyname": "Orange County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6061,
        "countyname": "Placer County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6063,
        "countyname": "Plumas County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6065,
        "countyname": "Riverside County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6067,
        "countyname": "Sacramento County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6069,
        "countyname": "San Benito County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6071,
        "countyname": "San Bernardino County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6073,
        "countyname": "San Diego County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6075,
        "countyname": "San Francisco County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6077,
        "countyname": "San Joaquin County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6079,
        "countyname": "San Luis Obispo County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6081,
        "countyname": "San Mateo County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6083,
        "countyname": "Santa Barbara County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6085,
        "countyname": "Santa Clara County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6087,
        "countyname": "Santa Cruz County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6089,
        "countyname": "Shasta County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6091,
        "countyname": "Sierra County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6093,
        "countyname": "Siskiyou County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6095,
        "countyname": "Solano County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6097,
        "countyname": "Sonoma County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6099,
        "countyname": "Stanislaus County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6101,
        "countyname": "Sutter County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6103,
        "countyname": "Tehama County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6105,
        "countyname": "Trinity County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6107,
        "countyname": "Tulare County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6109,
        "countyname": "Tuolumne County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6111,
        "countyname": "Ventura County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6113,
        "countyname": "Yolo County",
        "stateorprovince": "CA"
    },
    {
        "fips": 6115,
        "countyname": "Yuba County",
        "stateorprovince": "CA"
    },
    {
        "fips": 8001,
        "countyname": "Adams County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8003,
        "countyname": "Alamosa County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8005,
        "countyname": "Arapahoe County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8007,
        "countyname": "Archuleta County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8009,
        "countyname": "Baca County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8011,
        "countyname": "Bent County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8013,
        "countyname": "Boulder County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8015,
        "countyname": "Chaffee County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8017,
        "countyname": "Cheyenne County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8019,
        "countyname": "Clear Creek County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8021,
        "countyname": "Conejos County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8023,
        "countyname": "Costilla County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8025,
        "countyname": "Crowley County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8027,
        "countyname": "Custer County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8029,
        "countyname": "Delta County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8031,
        "countyname": "Denver County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8033,
        "countyname": "Dolores County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8035,
        "countyname": "Douglas County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8037,
        "countyname": "Eagle County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8039,
        "countyname": "Elbert County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8041,
        "countyname": "El Paso County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8043,
        "countyname": "Fremont County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8045,
        "countyname": "Garfield County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8047,
        "countyname": "Gilpin County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8049,
        "countyname": "Grand County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8051,
        "countyname": "Gunnison County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8053,
        "countyname": "Hinsdale County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8055,
        "countyname": "Huerfano County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8057,
        "countyname": "Jackson County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8059,
        "countyname": "Jefferson County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8061,
        "countyname": "Kiowa County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8063,
        "countyname": "Kit Carson County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8065,
        "countyname": "Lake County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8067,
        "countyname": "La Plata County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8069,
        "countyname": "Larimer County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8071,
        "countyname": "Las Animas County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8073,
        "countyname": "Lincoln County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8075,
        "countyname": "Logan County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8077,
        "countyname": "Mesa County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8079,
        "countyname": "Mineral County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8081,
        "countyname": "Moffat County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8083,
        "countyname": "Montezuma County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8085,
        "countyname": "Montrose County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8087,
        "countyname": "Morgan County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8089,
        "countyname": "Otero County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8091,
        "countyname": "Ouray County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8093,
        "countyname": "Park County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8095,
        "countyname": "Phillips County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8097,
        "countyname": "Pitkin County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8099,
        "countyname": "Prowers County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8101,
        "countyname": "Pueblo County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8103,
        "countyname": "Rio Blanco County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8105,
        "countyname": "Rio Grande County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8107,
        "countyname": "Routt County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8109,
        "countyname": "Saguache County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8111,
        "countyname": "San Juan County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8113,
        "countyname": "San Miguel County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8115,
        "countyname": "Sedgwick County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8117,
        "countyname": "Summit County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8119,
        "countyname": "Teller County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8121,
        "countyname": "Washington County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8123,
        "countyname": "Weld County",
        "stateorprovince": "CO"
    },
    {
        "fips": 8125,
        "countyname": "Yuma County",
        "stateorprovince": "CO"
    },
    {
        "fips": 9001,
        "countyname": "Fairfield County",
        "stateorprovince": "CT"
    },
    {
        "fips": 9003,
        "countyname": "Hartford County",
        "stateorprovince": "CT"
    },
    {
        "fips": 9005,
        "countyname": "Litchfield County",
        "stateorprovince": "CT"
    },
    {
        "fips": 9007,
        "countyname": "Middlesex County",
        "stateorprovince": "CT"
    },
    {
        "fips": 9009,
        "countyname": "New Haven County",
        "stateorprovince": "CT"
    },
    {
        "fips": 9011,
        "countyname": "New London County",
        "stateorprovince": "CT"
    },
    {
        "fips": 9013,
        "countyname": "Tolland County",
        "stateorprovince": "CT"
    },
    {
        "fips": 9015,
        "countyname": "Windham County",
        "stateorprovince": "CT"
    },
    {
        "fips": 10001,
        "countyname": "Kent County",
        "stateorprovince": "DE"
    },
    {
        "fips": 10003,
        "countyname": "New Castle County",
        "stateorprovince": "DE"
    },
    {
        "fips": 10005,
        "countyname": "Sussex County",
        "stateorprovince": "DE"
    },
    {
        "fips": 11001,
        "countyname": "District of Columbia",
        "stateorprovince": "DC"
    },
    {
        "fips": 12001,
        "countyname": "Alachua County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12003,
        "countyname": "Baker County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12005,
        "countyname": "Bay County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12007,
        "countyname": "Bradford County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12009,
        "countyname": "Brevard County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12011,
        "countyname": "Broward County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12013,
        "countyname": "Calhoun County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12015,
        "countyname": "Charlotte County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12017,
        "countyname": "Citrus County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12019,
        "countyname": "Clay County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12021,
        "countyname": "Collier County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12023,
        "countyname": "Columbia County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12027,
        "countyname": "DeSoto County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12029,
        "countyname": "Dixie County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12031,
        "countyname": "Duval County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12033,
        "countyname": "Escambia County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12035,
        "countyname": "Flagler County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12037,
        "countyname": "Franklin County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12039,
        "countyname": "Gadsden County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12041,
        "countyname": "Gilchrist County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12043,
        "countyname": "Glades County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12045,
        "countyname": "Gulf County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12047,
        "countyname": "Hamilton County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12049,
        "countyname": "Hardee County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12051,
        "countyname": "Hendry County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12053,
        "countyname": "Hernando County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12055,
        "countyname": "Highlands County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12057,
        "countyname": "Hillsborough County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12059,
        "countyname": "Holmes County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12061,
        "countyname": "Indian River County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12063,
        "countyname": "Jackson County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12065,
        "countyname": "Jefferson County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12067,
        "countyname": "Lafayette County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12069,
        "countyname": "Lake County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12071,
        "countyname": "Lee County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12073,
        "countyname": "Leon County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12075,
        "countyname": "Levy County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12077,
        "countyname": "Liberty County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12079,
        "countyname": "Madison County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12081,
        "countyname": "Manatee County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12083,
        "countyname": "Marion County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12085,
        "countyname": "Martin County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12086,
        "countyname": "Miami-Dade County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12087,
        "countyname": "Monroe County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12089,
        "countyname": "Nassau County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12091,
        "countyname": "Okaloosa County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12093,
        "countyname": "Okeechobee County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12095,
        "countyname": "Orange County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12097,
        "countyname": "Osceola County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12099,
        "countyname": "Palm Beach County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12101,
        "countyname": "Pasco County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12103,
        "countyname": "Pinellas County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12105,
        "countyname": "Polk County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12107,
        "countyname": "Putnam County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12109,
        "countyname": "St. Johns County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12111,
        "countyname": "St. Lucie County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12113,
        "countyname": "Santa Rosa County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12115,
        "countyname": "Sarasota County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12117,
        "countyname": "Seminole County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12119,
        "countyname": "Sumter County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12121,
        "countyname": "Suwannee County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12123,
        "countyname": "Taylor County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12125,
        "countyname": "Union County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12127,
        "countyname": "Volusia County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12129,
        "countyname": "Wakulla County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12131,
        "countyname": "Walton County",
        "stateorprovince": "FL"
    },
    {
        "fips": 12133,
        "countyname": "Washington County",
        "stateorprovince": "FL"
    },
    {
        "fips": 13001,
        "countyname": "Appling County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13003,
        "countyname": "Atkinson County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13005,
        "countyname": "Bacon County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13007,
        "countyname": "Baker County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13009,
        "countyname": "Baldwin County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13011,
        "countyname": "Banks County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13013,
        "countyname": "Barrow County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13015,
        "countyname": "Bartow County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13017,
        "countyname": "Ben Hill County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13019,
        "countyname": "Berrien County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13021,
        "countyname": "Bibb County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13023,
        "countyname": "Bleckley County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13025,
        "countyname": "Brantley County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13027,
        "countyname": "Brooks County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13029,
        "countyname": "Bryan County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13031,
        "countyname": "Bulloch County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13033,
        "countyname": "Burke County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13035,
        "countyname": "Butts County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13037,
        "countyname": "Calhoun County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13039,
        "countyname": "Camden County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13043,
        "countyname": "Candler County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13045,
        "countyname": "Carroll County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13047,
        "countyname": "Catoosa County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13049,
        "countyname": "Charlton County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13051,
        "countyname": "Chatham County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13053,
        "countyname": "Chattahoochee County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13055,
        "countyname": "Chattooga County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13057,
        "countyname": "Cherokee County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13059,
        "countyname": "Clarke County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13061,
        "countyname": "Clay County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13063,
        "countyname": "Clayton County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13065,
        "countyname": "Clinch County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13067,
        "countyname": "Cobb County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13069,
        "countyname": "Coffee County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13071,
        "countyname": "Colquitt County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13073,
        "countyname": "Columbia County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13075,
        "countyname": "Cook County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13077,
        "countyname": "Coweta County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13079,
        "countyname": "Crawford County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13081,
        "countyname": "Crisp County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13083,
        "countyname": "Dade County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13085,
        "countyname": "Dawson County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13087,
        "countyname": "Decatur County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13089,
        "countyname": "De Kalb County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13091,
        "countyname": "Dodge County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13093,
        "countyname": "Dooly County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13095,
        "countyname": "Dougherty County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13097,
        "countyname": "Douglas County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13099,
        "countyname": "Early County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13101,
        "countyname": "Echols County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13103,
        "countyname": "Effingham County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13105,
        "countyname": "Elbert County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13107,
        "countyname": "Emanuel County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13109,
        "countyname": "Evans County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13111,
        "countyname": "Fannin County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13113,
        "countyname": "Fayette County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13115,
        "countyname": "Floyd County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13117,
        "countyname": "Forsyth County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13119,
        "countyname": "Franklin County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13121,
        "countyname": "Fulton County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13123,
        "countyname": "Gilmer County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13125,
        "countyname": "Glascock County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13127,
        "countyname": "Glynn County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13129,
        "countyname": "Gordon County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13131,
        "countyname": "Grady County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13133,
        "countyname": "Greene County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13135,
        "countyname": "Gwinnett County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13137,
        "countyname": "Habersham County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13139,
        "countyname": "Hall County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13141,
        "countyname": "Hancock County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13143,
        "countyname": "Haralson County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13145,
        "countyname": "Harris County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13147,
        "countyname": "Hart County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13149,
        "countyname": "Heard County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13151,
        "countyname": "Henry County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13153,
        "countyname": "Houston County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13155,
        "countyname": "Irwin County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13157,
        "countyname": "Jackson County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13159,
        "countyname": "Jasper County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13161,
        "countyname": "Jeff Davis County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13163,
        "countyname": "Jefferson County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13165,
        "countyname": "Jenkins County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13167,
        "countyname": "Johnson County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13169,
        "countyname": "Jones County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13171,
        "countyname": "Lamar County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13173,
        "countyname": "Lanier County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13175,
        "countyname": "Laurens County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13177,
        "countyname": "Lee County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13179,
        "countyname": "Liberty County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13181,
        "countyname": "Lincoln County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13183,
        "countyname": "Long County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13185,
        "countyname": "Lowndes County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13187,
        "countyname": "Lumpkin County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13189,
        "countyname": "McDuffie County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13191,
        "countyname": "McIntosh County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13193,
        "countyname": "Macon County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13195,
        "countyname": "Madison County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13197,
        "countyname": "Marion County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13199,
        "countyname": "Meriwether County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13201,
        "countyname": "Miller County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13205,
        "countyname": "Mitchell County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13207,
        "countyname": "Monroe County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13209,
        "countyname": "Montgomery County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13211,
        "countyname": "Morgan County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13213,
        "countyname": "Murray County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13215,
        "countyname": "Muscogee County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13217,
        "countyname": "Newton County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13219,
        "countyname": "Oconee County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13221,
        "countyname": "Oglethorpe County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13223,
        "countyname": "Paulding County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13225,
        "countyname": "Peach County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13227,
        "countyname": "Pickens County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13229,
        "countyname": "Pierce County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13231,
        "countyname": "Pike County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13233,
        "countyname": "Polk County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13235,
        "countyname": "Pulaski County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13237,
        "countyname": "Putnam County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13239,
        "countyname": "Quitman County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13241,
        "countyname": "Rabun County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13243,
        "countyname": "Randolph County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13245,
        "countyname": "Richmond County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13247,
        "countyname": "Rockdale County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13249,
        "countyname": "Schley County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13251,
        "countyname": "Screven County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13253,
        "countyname": "Seminole County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13255,
        "countyname": "Spalding County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13257,
        "countyname": "Stephens County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13259,
        "countyname": "Stewart County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13261,
        "countyname": "Sumter County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13263,
        "countyname": "Talbot County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13265,
        "countyname": "Taliaferro County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13267,
        "countyname": "Tattnall County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13269,
        "countyname": "Taylor County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13271,
        "countyname": "Telfair County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13273,
        "countyname": "Terrell County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13275,
        "countyname": "Thomas County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13277,
        "countyname": "Tift County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13279,
        "countyname": "Toombs County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13281,
        "countyname": "Towns County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13283,
        "countyname": "Treutlen County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13285,
        "countyname": "Troup County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13287,
        "countyname": "Turner County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13289,
        "countyname": "Twiggs County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13291,
        "countyname": "Union County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13293,
        "countyname": "Upson County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13295,
        "countyname": "Walker County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13297,
        "countyname": "Walton County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13299,
        "countyname": "Ware County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13301,
        "countyname": "Warren County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13303,
        "countyname": "Washington County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13305,
        "countyname": "Wayne County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13307,
        "countyname": "Webster County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13309,
        "countyname": "Wheeler County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13311,
        "countyname": "White County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13313,
        "countyname": "Whitfield County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13315,
        "countyname": "Wilcox County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13317,
        "countyname": "Wilkes County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13319,
        "countyname": "Wilkinson County",
        "stateorprovince": "GA"
    },
    {
        "fips": 13321,
        "countyname": "Worth County",
        "stateorprovince": "GA"
    },
    {
        "fips": 15001,
        "countyname": "Hawaii County",
        "stateorprovince": "HI"
    },
    {
        "fips": 15003,
        "countyname": "Honolulu County",
        "stateorprovince": "HI"
    },
    {
        "fips": 15005,
        "countyname": "Kalawao County",
        "stateorprovince": "HI"
    },
    {
        "fips": 15007,
        "countyname": "Kauai County",
        "stateorprovince": "HI"
    },
    {
        "fips": 15009,
        "countyname": "Maui County",
        "stateorprovince": "HI"
    },
    {
        "fips": 16001,
        "countyname": "Ada County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16003,
        "countyname": "Adams County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16005,
        "countyname": "Bannock County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16007,
        "countyname": "Bear Lake County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16009,
        "countyname": "Benewah County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16011,
        "countyname": "Bingham County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16013,
        "countyname": "Blaine County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16015,
        "countyname": "Boise County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16017,
        "countyname": "Bonner County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16019,
        "countyname": "Bonneville County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16021,
        "countyname": "Boundary County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16023,
        "countyname": "Butte County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16025,
        "countyname": "Camas County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16027,
        "countyname": "Canyon County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16029,
        "countyname": "Caribou County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16031,
        "countyname": "Cassia County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16033,
        "countyname": "Clark County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16035,
        "countyname": "Clearwater County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16037,
        "countyname": "Custer County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16039,
        "countyname": "Elmore County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16041,
        "countyname": "Franklin County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16043,
        "countyname": "Fremont County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16045,
        "countyname": "Gem County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16047,
        "countyname": "Gooding County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16049,
        "countyname": "Idaho County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16051,
        "countyname": "Jefferson County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16053,
        "countyname": "Jerome County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16055,
        "countyname": "Kootenai County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16057,
        "countyname": "Latah County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16059,
        "countyname": "Lemhi County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16061,
        "countyname": "Lewis County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16063,
        "countyname": "Lincoln County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16065,
        "countyname": "Madison County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16067,
        "countyname": "Minidoka County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16069,
        "countyname": "Nez Perce County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16071,
        "countyname": "Oneida County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16073,
        "countyname": "Owyhee County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16075,
        "countyname": "Payette County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16077,
        "countyname": "Power County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16079,
        "countyname": "Shoshone County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16081,
        "countyname": "Teton County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16083,
        "countyname": "Twin Falls County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16085,
        "countyname": "Valley County",
        "stateorprovince": "ID"
    },
    {
        "fips": 16087,
        "countyname": "Washington County",
        "stateorprovince": "ID"
    },
    {
        "fips": 17001,
        "countyname": "Adams County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17003,
        "countyname": "Alexander County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17005,
        "countyname": "Bond County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17007,
        "countyname": "Boone County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17009,
        "countyname": "Brown County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17011,
        "countyname": "Bureau County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17013,
        "countyname": "Calhoun County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17015,
        "countyname": "Carroll County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17017,
        "countyname": "Cass County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17019,
        "countyname": "Champaign County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17021,
        "countyname": "Christian County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17023,
        "countyname": "Clark County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17025,
        "countyname": "Clay County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17027,
        "countyname": "Clinton County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17029,
        "countyname": "Coles County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17031,
        "countyname": "Cook County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17033,
        "countyname": "Crawford County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17035,
        "countyname": "Cumberland County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17037,
        "countyname": "DeKalb County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17039,
        "countyname": "De Witt County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17041,
        "countyname": "Douglas County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17043,
        "countyname": "Du Page County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17045,
        "countyname": "Edgar County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17047,
        "countyname": "Edwards County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17049,
        "countyname": "Effingham County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17051,
        "countyname": "Fayette County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17053,
        "countyname": "Ford County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17055,
        "countyname": "Franklin County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17057,
        "countyname": "Fulton County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17059,
        "countyname": "Gallatin County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17061,
        "countyname": "Greene County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17063,
        "countyname": "Grundy County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17065,
        "countyname": "Hamilton County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17067,
        "countyname": "Hancock County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17069,
        "countyname": "Hardin County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17071,
        "countyname": "Henderson County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17073,
        "countyname": "Henry County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17075,
        "countyname": "Iroquois County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17077,
        "countyname": "Jackson County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17079,
        "countyname": "Jasper County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17081,
        "countyname": "Jefferson County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17083,
        "countyname": "Jersey County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17085,
        "countyname": "Jo Daviess County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17087,
        "countyname": "Johnson County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17089,
        "countyname": "Kane County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17091,
        "countyname": "Kankakee County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17093,
        "countyname": "Kendall County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17095,
        "countyname": "Knox County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17097,
        "countyname": "Lake County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17099,
        "countyname": "La Salle County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17101,
        "countyname": "Lawrence County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17103,
        "countyname": "Lee County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17105,
        "countyname": "Livingston County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17107,
        "countyname": "Logan County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17109,
        "countyname": "McDonough County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17111,
        "countyname": "McHenry County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17113,
        "countyname": "McLean County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17115,
        "countyname": "Macon County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17117,
        "countyname": "Macoupin County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17119,
        "countyname": "Madison County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17121,
        "countyname": "Marion County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17123,
        "countyname": "Marshall County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17125,
        "countyname": "Mason County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17127,
        "countyname": "Massac County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17129,
        "countyname": "Menard County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17131,
        "countyname": "Mercer County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17133,
        "countyname": "Monroe County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17135,
        "countyname": "Montgomery County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17137,
        "countyname": "Morgan County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17139,
        "countyname": "Moultrie County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17141,
        "countyname": "Ogle County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17143,
        "countyname": "Peoria County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17145,
        "countyname": "Perry County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17147,
        "countyname": "Piatt County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17149,
        "countyname": "Pike County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17151,
        "countyname": "Pope County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17153,
        "countyname": "Pulaski County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17155,
        "countyname": "Putnam County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17157,
        "countyname": "Randolph County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17159,
        "countyname": "Richland County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17161,
        "countyname": "Rock Island County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17163,
        "countyname": "St. Clair County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17165,
        "countyname": "Saline County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17167,
        "countyname": "Sangamon County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17169,
        "countyname": "Schuyler County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17171,
        "countyname": "Scott County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17173,
        "countyname": "Shelby County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17175,
        "countyname": "Stark County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17177,
        "countyname": "Stephenson County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17179,
        "countyname": "Tazewell County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17181,
        "countyname": "Union County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17183,
        "countyname": "Vermilion County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17185,
        "countyname": "Wabash County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17187,
        "countyname": "Warren County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17189,
        "countyname": "Washington County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17191,
        "countyname": "Wayne County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17193,
        "countyname": "White County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17195,
        "countyname": "Whiteside County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17197,
        "countyname": "Will County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17199,
        "countyname": "Williamson County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17201,
        "countyname": "Winnebago County",
        "stateorprovince": "IL"
    },
    {
        "fips": 17203,
        "countyname": "Woodford County",
        "stateorprovince": "IL"
    },
    {
        "fips": 18001,
        "countyname": "Adams County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18003,
        "countyname": "Allen County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18005,
        "countyname": "Bartholomew County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18007,
        "countyname": "Benton County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18009,
        "countyname": "Blackford County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18011,
        "countyname": "Boone County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18013,
        "countyname": "Brown County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18015,
        "countyname": "Carroll County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18017,
        "countyname": "Cass County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18019,
        "countyname": "Clark County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18021,
        "countyname": "Clay County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18023,
        "countyname": "Clinton County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18025,
        "countyname": "Crawford County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18027,
        "countyname": "Daviess County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18029,
        "countyname": "Dearborn County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18031,
        "countyname": "Decatur County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18033,
        "countyname": "De Kalb County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18035,
        "countyname": "Delaware County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18037,
        "countyname": "Dubois County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18039,
        "countyname": "Elkhart County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18041,
        "countyname": "Fayette County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18043,
        "countyname": "Floyd County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18045,
        "countyname": "Fountain County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18047,
        "countyname": "Franklin County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18049,
        "countyname": "Fulton County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18051,
        "countyname": "Gibson County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18053,
        "countyname": "Grant County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18055,
        "countyname": "Greene County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18057,
        "countyname": "Hamilton County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18059,
        "countyname": "Hancock County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18061,
        "countyname": "Harrison County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18063,
        "countyname": "Hendricks County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18065,
        "countyname": "Henry County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18067,
        "countyname": "Howard County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18069,
        "countyname": "Huntington County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18071,
        "countyname": "Jackson County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18073,
        "countyname": "Jasper County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18075,
        "countyname": "Jay County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18077,
        "countyname": "Jefferson County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18079,
        "countyname": "Jennings County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18081,
        "countyname": "Johnson County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18083,
        "countyname": "Knox County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18085,
        "countyname": "Kosciusko County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18087,
        "countyname": "Lagrange County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18089,
        "countyname": "Lake County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18091,
        "countyname": "La Porte County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18093,
        "countyname": "Lawrence County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18095,
        "countyname": "Madison County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18097,
        "countyname": "Marion County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18099,
        "countyname": "Marshall County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18101,
        "countyname": "Martin County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18103,
        "countyname": "Miami County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18105,
        "countyname": "Monroe County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18107,
        "countyname": "Montgomery County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18109,
        "countyname": "Morgan County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18111,
        "countyname": "Newton County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18113,
        "countyname": "Noble County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18115,
        "countyname": "Ohio County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18117,
        "countyname": "Orange County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18119,
        "countyname": "Owen County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18121,
        "countyname": "Parke County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18123,
        "countyname": "Perry County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18125,
        "countyname": "Pike County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18127,
        "countyname": "Porter County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18129,
        "countyname": "Posey County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18131,
        "countyname": "Pulaski County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18133,
        "countyname": "Putnam County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18135,
        "countyname": "Randolph County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18137,
        "countyname": "Ripley County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18139,
        "countyname": "Rush County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18141,
        "countyname": "St. Joseph County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18143,
        "countyname": "Scott County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18145,
        "countyname": "Shelby County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18147,
        "countyname": "Spencer County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18149,
        "countyname": "Starke County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18151,
        "countyname": "Steuben County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18153,
        "countyname": "Sullivan County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18155,
        "countyname": "Switzerland County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18157,
        "countyname": "Tippecanoe County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18159,
        "countyname": "Tipton County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18161,
        "countyname": "Union County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18163,
        "countyname": "Vanderburgh County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18165,
        "countyname": "Vermillion County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18167,
        "countyname": "Vigo County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18169,
        "countyname": "Wabash County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18171,
        "countyname": "Warren County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18173,
        "countyname": "Warrick County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18175,
        "countyname": "Washington County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18177,
        "countyname": "Wayne County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18179,
        "countyname": "Wells County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18181,
        "countyname": "White County",
        "stateorprovince": "IN"
    },
    {
        "fips": 18183,
        "countyname": "Whitley County",
        "stateorprovince": "IN"
    },
    {
        "fips": 19001,
        "countyname": "Adair County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19003,
        "countyname": "Adams County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19005,
        "countyname": "Allamakee County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19007,
        "countyname": "Appanoose County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19009,
        "countyname": "Audubon County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19011,
        "countyname": "Benton County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19013,
        "countyname": "Black Hawk County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19015,
        "countyname": "Boone County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19017,
        "countyname": "Bremer County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19019,
        "countyname": "Buchanan County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19021,
        "countyname": "Buena Vista County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19023,
        "countyname": "Butler County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19025,
        "countyname": "Calhoun County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19027,
        "countyname": "Carroll County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19029,
        "countyname": "Cass County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19031,
        "countyname": "Cedar County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19033,
        "countyname": "Cerro Gordo County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19035,
        "countyname": "Cherokee County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19037,
        "countyname": "Chickasaw County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19039,
        "countyname": "Clarke County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19041,
        "countyname": "Clay County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19043,
        "countyname": "Clayton County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19045,
        "countyname": "Clinton County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19047,
        "countyname": "Crawford County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19049,
        "countyname": "Dallas County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19051,
        "countyname": "Davis County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19053,
        "countyname": "Decatur County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19055,
        "countyname": "Delaware County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19057,
        "countyname": "Des Moines County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19059,
        "countyname": "Dickinson County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19061,
        "countyname": "Dubuque County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19063,
        "countyname": "Emmet County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19065,
        "countyname": "Fayette County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19067,
        "countyname": "Floyd County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19069,
        "countyname": "Franklin County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19071,
        "countyname": "Fremont County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19073,
        "countyname": "Greene County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19075,
        "countyname": "Grundy County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19077,
        "countyname": "Guthrie County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19079,
        "countyname": "Hamilton County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19081,
        "countyname": "Hancock County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19083,
        "countyname": "Hardin County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19085,
        "countyname": "Harrison County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19087,
        "countyname": "Henry County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19089,
        "countyname": "Howard County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19091,
        "countyname": "Humboldt County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19093,
        "countyname": "Ida County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19095,
        "countyname": "Iowa County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19097,
        "countyname": "Jackson County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19099,
        "countyname": "Jasper County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19101,
        "countyname": "Jefferson County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19103,
        "countyname": "Johnson County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19105,
        "countyname": "Jones County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19107,
        "countyname": "Keokuk County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19109,
        "countyname": "Kossuth County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19111,
        "countyname": "Lee County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19113,
        "countyname": "Linn County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19115,
        "countyname": "Louisa County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19117,
        "countyname": "Lucas County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19119,
        "countyname": "Lyon County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19121,
        "countyname": "Madison County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19123,
        "countyname": "Mahaska County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19125,
        "countyname": "Marion County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19127,
        "countyname": "Marshall County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19129,
        "countyname": "Mills County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19131,
        "countyname": "Mitchell County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19133,
        "countyname": "Monona County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19135,
        "countyname": "Monroe County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19137,
        "countyname": "Montgomery County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19139,
        "countyname": "Muscatine County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19141,
        "countyname": "O'Brien County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19143,
        "countyname": "Osceola County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19145,
        "countyname": "Page County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19147,
        "countyname": "Palo Alto County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19149,
        "countyname": "Plymouth County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19151,
        "countyname": "Pocahontas County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19153,
        "countyname": "Polk County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19155,
        "countyname": "Pottawattamie County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19157,
        "countyname": "Poweshiek County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19159,
        "countyname": "Ringgold County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19161,
        "countyname": "Sac County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19163,
        "countyname": "Scott County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19165,
        "countyname": "Shelby County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19167,
        "countyname": "Sioux County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19169,
        "countyname": "Story County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19171,
        "countyname": "Tama County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19173,
        "countyname": "Taylor County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19175,
        "countyname": "Union County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19177,
        "countyname": "Van Buren County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19179,
        "countyname": "Wapello County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19181,
        "countyname": "Warren County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19183,
        "countyname": "Washington County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19185,
        "countyname": "Wayne County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19187,
        "countyname": "Webster County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19189,
        "countyname": "Winnebago County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19191,
        "countyname": "Winneshiek County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19193,
        "countyname": "Woodbury County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19195,
        "countyname": "Worth County",
        "stateorprovince": "IA"
    },
    {
        "fips": 19197,
        "countyname": "Wright County",
        "stateorprovince": "IA"
    },
    {
        "fips": 20001,
        "countyname": "Allen County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20003,
        "countyname": "Anderson County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20005,
        "countyname": "Atchison County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20007,
        "countyname": "Barber County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20009,
        "countyname": "Barton County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20011,
        "countyname": "Bourbon County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20013,
        "countyname": "Brown County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20015,
        "countyname": "Butler County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20017,
        "countyname": "Chase County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20019,
        "countyname": "Chautauqua County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20021,
        "countyname": "Cherokee County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20023,
        "countyname": "Cheyenne County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20025,
        "countyname": "Clark County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20027,
        "countyname": "Clay County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20029,
        "countyname": "Cloud County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20031,
        "countyname": "Coffey County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20033,
        "countyname": "Comanche County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20035,
        "countyname": "Cowley County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20037,
        "countyname": "Crawford County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20039,
        "countyname": "Decatur County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20041,
        "countyname": "Dickinson County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20043,
        "countyname": "Doniphan County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20045,
        "countyname": "Douglas County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20047,
        "countyname": "Edwards County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20049,
        "countyname": "Elk County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20051,
        "countyname": "Ellis County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20053,
        "countyname": "Ellsworth County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20055,
        "countyname": "Finney County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20057,
        "countyname": "Ford County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20059,
        "countyname": "Franklin County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20061,
        "countyname": "Geary County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20063,
        "countyname": "Gove County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20065,
        "countyname": "Graham County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20067,
        "countyname": "Grant County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20069,
        "countyname": "Gray County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20071,
        "countyname": "Greeley County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20073,
        "countyname": "Greenwood County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20075,
        "countyname": "Hamilton County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20077,
        "countyname": "Harper County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20079,
        "countyname": "Harvey County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20081,
        "countyname": "Haskell County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20083,
        "countyname": "Hodgeman County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20085,
        "countyname": "Jackson County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20087,
        "countyname": "Jefferson County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20089,
        "countyname": "Jewell County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20091,
        "countyname": "Johnson County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20093,
        "countyname": "Kearny County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20095,
        "countyname": "Kingman County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20097,
        "countyname": "Kiowa County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20099,
        "countyname": "Labette County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20101,
        "countyname": "Lane County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20103,
        "countyname": "Leavenworth County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20105,
        "countyname": "Lincoln County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20107,
        "countyname": "Linn County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20109,
        "countyname": "Logan County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20111,
        "countyname": "Lyon County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20113,
        "countyname": "McPherson County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20115,
        "countyname": "Marion County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20117,
        "countyname": "Marshall County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20119,
        "countyname": "Meade County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20121,
        "countyname": "Miami County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20123,
        "countyname": "Mitchell County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20125,
        "countyname": "Montgomery County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20127,
        "countyname": "Morris County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20129,
        "countyname": "Morton County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20131,
        "countyname": "Nemaha County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20133,
        "countyname": "Neosho County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20135,
        "countyname": "Ness County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20137,
        "countyname": "Norton County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20139,
        "countyname": "Osage County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20141,
        "countyname": "Osborne County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20143,
        "countyname": "Ottawa County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20145,
        "countyname": "Pawnee County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20147,
        "countyname": "Phillips County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20149,
        "countyname": "Pottawatomie County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20151,
        "countyname": "Pratt County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20153,
        "countyname": "Rawlins County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20155,
        "countyname": "Reno County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20157,
        "countyname": "Republic County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20159,
        "countyname": "Rice County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20161,
        "countyname": "Riley County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20163,
        "countyname": "Rooks County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20165,
        "countyname": "Rush County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20167,
        "countyname": "Russell County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20169,
        "countyname": "Saline County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20171,
        "countyname": "Scott County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20173,
        "countyname": "Sedgwick County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20175,
        "countyname": "Seward County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20177,
        "countyname": "Shawnee County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20179,
        "countyname": "Sheridan County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20181,
        "countyname": "Sherman County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20183,
        "countyname": "Smith County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20185,
        "countyname": "Stafford County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20187,
        "countyname": "Stanton County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20189,
        "countyname": "Stevens County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20191,
        "countyname": "Sumner County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20193,
        "countyname": "Thomas County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20195,
        "countyname": "Trego County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20197,
        "countyname": "Wabaunsee County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20199,
        "countyname": "Wallace County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20201,
        "countyname": "Washington County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20203,
        "countyname": "Wichita County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20205,
        "countyname": "Wilson County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20207,
        "countyname": "Woodson County",
        "stateorprovince": "KS"
    },
    {
        "fips": 20209,
        "countyname": "Wyandotte County",
        "stateorprovince": "KS"
    },
    {
        "fips": 21001,
        "countyname": "Adair County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21003,
        "countyname": "Allen County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21005,
        "countyname": "Anderson County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21007,
        "countyname": "Ballard County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21009,
        "countyname": "Barren County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21011,
        "countyname": "Bath County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21013,
        "countyname": "Bell County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21015,
        "countyname": "Boone County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21017,
        "countyname": "Bourbon County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21019,
        "countyname": "Boyd County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21021,
        "countyname": "Boyle County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21023,
        "countyname": "Bracken County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21025,
        "countyname": "Breathitt County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21027,
        "countyname": "Breckinridge County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21029,
        "countyname": "Bullitt County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21031,
        "countyname": "Butler County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21033,
        "countyname": "Caldwell County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21035,
        "countyname": "Calloway County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21037,
        "countyname": "Campbell County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21039,
        "countyname": "Carlisle County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21041,
        "countyname": "Carroll County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21043,
        "countyname": "Carter County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21045,
        "countyname": "Casey County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21047,
        "countyname": "Christian County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21049,
        "countyname": "Clark County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21051,
        "countyname": "Clay County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21053,
        "countyname": "Clinton County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21055,
        "countyname": "Crittenden County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21057,
        "countyname": "Cumberland County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21059,
        "countyname": "Daviess County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21061,
        "countyname": "Edmonson County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21063,
        "countyname": "Elliott County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21065,
        "countyname": "Estill County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21067,
        "countyname": "Fayette County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21069,
        "countyname": "Fleming County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21071,
        "countyname": "Floyd County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21073,
        "countyname": "Franklin County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21075,
        "countyname": "Fulton County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21077,
        "countyname": "Gallatin County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21079,
        "countyname": "Garrard County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21081,
        "countyname": "Grant County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21083,
        "countyname": "Graves County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21085,
        "countyname": "Grayson County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21087,
        "countyname": "Green County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21089,
        "countyname": "Greenup County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21091,
        "countyname": "Hancock County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21093,
        "countyname": "Hardin County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21095,
        "countyname": "Harlan County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21097,
        "countyname": "Harrison County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21099,
        "countyname": "Hart County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21101,
        "countyname": "Henderson County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21103,
        "countyname": "Henry County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21105,
        "countyname": "Hickman County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21107,
        "countyname": "Hopkins County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21109,
        "countyname": "Jackson County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21111,
        "countyname": "Jefferson County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21113,
        "countyname": "Jessamine County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21115,
        "countyname": "Johnson County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21117,
        "countyname": "Kenton County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21119,
        "countyname": "Knott County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21121,
        "countyname": "Knox County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21123,
        "countyname": "Larue County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21125,
        "countyname": "Laurel County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21127,
        "countyname": "Lawrence County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21129,
        "countyname": "Lee County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21131,
        "countyname": "Leslie County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21133,
        "countyname": "Letcher County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21135,
        "countyname": "Lewis County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21137,
        "countyname": "Lincoln County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21139,
        "countyname": "Livingston County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21141,
        "countyname": "Logan County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21143,
        "countyname": "Lyon County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21145,
        "countyname": "McCracken County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21147,
        "countyname": "McCreary County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21149,
        "countyname": "McLean County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21151,
        "countyname": "Madison County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21153,
        "countyname": "Magoffin County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21155,
        "countyname": "Marion County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21157,
        "countyname": "Marshall County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21159,
        "countyname": "Martin County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21161,
        "countyname": "Mason County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21163,
        "countyname": "Meade County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21165,
        "countyname": "Menifee County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21167,
        "countyname": "Mercer County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21169,
        "countyname": "Metcalfe County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21171,
        "countyname": "Monroe County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21173,
        "countyname": "Montgomery County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21175,
        "countyname": "Morgan County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21177,
        "countyname": "Muhlenberg County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21179,
        "countyname": "Nelson County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21181,
        "countyname": "Nicholas County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21183,
        "countyname": "Ohio County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21185,
        "countyname": "Oldham County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21187,
        "countyname": "Owen County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21189,
        "countyname": "Owsley County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21191,
        "countyname": "Pendleton County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21193,
        "countyname": "Perry County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21195,
        "countyname": "Pike County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21197,
        "countyname": "Powell County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21199,
        "countyname": "Pulaski County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21201,
        "countyname": "Robertson County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21203,
        "countyname": "Rockcastle County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21205,
        "countyname": "Rowan County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21207,
        "countyname": "Russell County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21209,
        "countyname": "Scott County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21211,
        "countyname": "Shelby County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21213,
        "countyname": "Simpson County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21215,
        "countyname": "Spencer County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21217,
        "countyname": "Taylor County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21219,
        "countyname": "Todd County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21221,
        "countyname": "Trigg County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21223,
        "countyname": "Trimble County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21225,
        "countyname": "Union County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21227,
        "countyname": "Warren County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21229,
        "countyname": "Washington County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21231,
        "countyname": "Wayne County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21233,
        "countyname": "Webster County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21235,
        "countyname": "Whitley County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21237,
        "countyname": "Wolfe County",
        "stateorprovince": "KY"
    },
    {
        "fips": 21239,
        "countyname": "Woodford County",
        "stateorprovince": "KY"
    },
    {
        "fips": 22001,
        "countyname": "Acadia Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22003,
        "countyname": "Allen Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22005,
        "countyname": "Ascension Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22007,
        "countyname": "Assumption Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22009,
        "countyname": "Avoyelles Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22011,
        "countyname": "Beauregard Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22013,
        "countyname": "Bienville Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22015,
        "countyname": "Bossier Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22017,
        "countyname": "Caddo Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22019,
        "countyname": "Calcasieu Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22021,
        "countyname": "Caldwell Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22023,
        "countyname": "Cameron Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22025,
        "countyname": "Catahoula Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22027,
        "countyname": "Claiborne Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22029,
        "countyname": "Concordia Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22031,
        "countyname": "De Soto Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22033,
        "countyname": "East Baton Rouge Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22035,
        "countyname": "East Carroll Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22037,
        "countyname": "East Feliciana Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22039,
        "countyname": "Evangeline Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22041,
        "countyname": "Franklin Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22043,
        "countyname": "Grant Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22045,
        "countyname": "Iberia Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22047,
        "countyname": "Iberville Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22049,
        "countyname": "Jackson Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22051,
        "countyname": "Jefferson Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22053,
        "countyname": "Jefferson Davis Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22055,
        "countyname": "Lafayette Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22057,
        "countyname": "Lafourche Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22059,
        "countyname": "La Salle Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22061,
        "countyname": "Lincoln Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22063,
        "countyname": "Livingston Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22065,
        "countyname": "Madison Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22067,
        "countyname": "Morehouse Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22069,
        "countyname": "Natchitoches Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22071,
        "countyname": "Orleans Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22073,
        "countyname": "Ouachita Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22075,
        "countyname": "Plaquemines Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22077,
        "countyname": "Pointe Coupee Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22079,
        "countyname": "Rapides Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22081,
        "countyname": "Red River Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22083,
        "countyname": "Richland Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22085,
        "countyname": "Sabine Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22087,
        "countyname": "St. Bernard Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22089,
        "countyname": "St. Charles Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22091,
        "countyname": "St. Helena Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22093,
        "countyname": "St. James Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22095,
        "countyname": "St. John the Baptist Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22097,
        "countyname": "St. Landry Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22099,
        "countyname": "St. Martin Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22101,
        "countyname": "St. Mary Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22103,
        "countyname": "St. Tammany Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22105,
        "countyname": "Tangipahoa Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22107,
        "countyname": "Tensas Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22109,
        "countyname": "Terrebonne Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22111,
        "countyname": "Union Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22113,
        "countyname": "Vermilion Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22115,
        "countyname": "Vernon Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22117,
        "countyname": "Washington Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22119,
        "countyname": "Webster Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22121,
        "countyname": "West Baton Rouge Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22123,
        "countyname": "West Carroll Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22125,
        "countyname": "West Feliciana Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 22127,
        "countyname": "Winn Parish",
        "stateorprovince": "LA"
    },
    {
        "fips": 23001,
        "countyname": "Androscoggin County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23003,
        "countyname": "Aroostook County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23005,
        "countyname": "Cumberland County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23007,
        "countyname": "Franklin County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23009,
        "countyname": "Hancock County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23011,
        "countyname": "Kennebec County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23013,
        "countyname": "Knox County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23015,
        "countyname": "Lincoln County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23017,
        "countyname": "Oxford County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23019,
        "countyname": "Penobscot County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23021,
        "countyname": "Piscataquis County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23023,
        "countyname": "Sagadahoc County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23025,
        "countyname": "Somerset County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23027,
        "countyname": "Waldo County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23029,
        "countyname": "Washington County",
        "stateorprovince": "ME"
    },
    {
        "fips": 23031,
        "countyname": "York County",
        "stateorprovince": "ME"
    },
    {
        "fips": 24001,
        "countyname": "Allegany County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24003,
        "countyname": "Anne Arundel County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24005,
        "countyname": "Baltimore County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24009,
        "countyname": "Calvert County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24011,
        "countyname": "Caroline County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24013,
        "countyname": "Carroll County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24015,
        "countyname": "Cecil County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24017,
        "countyname": "Charles County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24019,
        "countyname": "Dorchester County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24021,
        "countyname": "Frederick County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24023,
        "countyname": "Garrett County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24025,
        "countyname": "Harford County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24027,
        "countyname": "Howard County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24029,
        "countyname": "Kent County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24031,
        "countyname": "Montgomery County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24033,
        "countyname": "Prince George's County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24035,
        "countyname": "Queen Anne's County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24037,
        "countyname": "St. Mary's County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24039,
        "countyname": "Somerset County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24041,
        "countyname": "Talbot County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24043,
        "countyname": "Washington County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24045,
        "countyname": "Wicomico County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24047,
        "countyname": "Worcester County",
        "stateorprovince": "MD"
    },
    {
        "fips": 24510,
        "countyname": "Baltimore city",
        "stateorprovince": "MD"
    },
    {
        "fips": 25001,
        "countyname": "Barnstable County",
        "stateorprovince": "MA"
    },
    {
        "fips": 25003,
        "countyname": "Berkshire County",
        "stateorprovince": "MA"
    },
    {
        "fips": 25005,
        "countyname": "Bristol County",
        "stateorprovince": "MA"
    },
    {
        "fips": 25007,
        "countyname": "Dukes County",
        "stateorprovince": "MA"
    },
    {
        "fips": 25009,
        "countyname": "Essex County",
        "stateorprovince": "MA"
    },
    {
        "fips": 25011,
        "countyname": "Franklin County",
        "stateorprovince": "MA"
    },
    {
        "fips": 25013,
        "countyname": "Hampden County",
        "stateorprovince": "MA"
    },
    {
        "fips": 25015,
        "countyname": "Hampshire County",
        "stateorprovince": "MA"
    },
    {
        "fips": 25017,
        "countyname": "Middlesex County",
        "stateorprovince": "MA"
    },
    {
        "fips": 25019,
        "countyname": "Nantucket County",
        "stateorprovince": "MA"
    },
    {
        "fips": 25021,
        "countyname": "Norfolk County",
        "stateorprovince": "MA"
    },
    {
        "fips": 25023,
        "countyname": "Plymouth County",
        "stateorprovince": "MA"
    },
    {
        "fips": 25025,
        "countyname": "Suffolk County",
        "stateorprovince": "MA"
    },
    {
        "fips": 25027,
        "countyname": "Worcester County",
        "stateorprovince": "MA"
    },
    {
        "fips": 26001,
        "countyname": "Alcona County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26003,
        "countyname": "Alger County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26005,
        "countyname": "Allegan County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26007,
        "countyname": "Alpena County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26009,
        "countyname": "Antrim County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26011,
        "countyname": "Arenac County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26013,
        "countyname": "Baraga County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26015,
        "countyname": "Barry County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26017,
        "countyname": "Bay County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26019,
        "countyname": "Benzie County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26021,
        "countyname": "Berrien County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26023,
        "countyname": "Branch County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26025,
        "countyname": "Calhoun County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26027,
        "countyname": "Cass County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26029,
        "countyname": "Charlevoix County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26031,
        "countyname": "Cheboygan County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26033,
        "countyname": "Chippewa County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26035,
        "countyname": "Clare County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26037,
        "countyname": "Clinton County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26039,
        "countyname": "Crawford County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26041,
        "countyname": "Delta County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26043,
        "countyname": "Dickinson County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26045,
        "countyname": "Eaton County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26047,
        "countyname": "Emmet County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26049,
        "countyname": "Genesee County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26051,
        "countyname": "Gladwin County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26053,
        "countyname": "Gogebic County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26055,
        "countyname": "Grand Traverse County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26057,
        "countyname": "Gratiot County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26059,
        "countyname": "Hillsdale County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26061,
        "countyname": "Houghton County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26063,
        "countyname": "Huron County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26065,
        "countyname": "Ingham County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26067,
        "countyname": "Ionia County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26069,
        "countyname": "Iosco County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26071,
        "countyname": "Iron County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26073,
        "countyname": "Isabella County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26075,
        "countyname": "Jackson County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26077,
        "countyname": "Kalamazoo County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26079,
        "countyname": "Kalkaska County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26081,
        "countyname": "Kent County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26083,
        "countyname": "Keweenaw County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26085,
        "countyname": "Lake County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26087,
        "countyname": "Lapeer County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26089,
        "countyname": "Leelanau County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26091,
        "countyname": "Lenawee County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26093,
        "countyname": "Livingston County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26095,
        "countyname": "Luce County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26097,
        "countyname": "Mackinac County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26099,
        "countyname": "Macomb County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26101,
        "countyname": "Manistee County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26103,
        "countyname": "Marquette County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26105,
        "countyname": "Mason County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26107,
        "countyname": "Mecosta County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26109,
        "countyname": "Menominee County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26111,
        "countyname": "Midland County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26113,
        "countyname": "Missaukee County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26115,
        "countyname": "Monroe County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26117,
        "countyname": "Montcalm County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26119,
        "countyname": "Montmorency County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26121,
        "countyname": "Muskegon County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26123,
        "countyname": "Newaygo County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26125,
        "countyname": "Oakland County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26127,
        "countyname": "Oceana County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26129,
        "countyname": "Ogemaw County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26131,
        "countyname": "Ontonagon County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26133,
        "countyname": "Osceola County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26135,
        "countyname": "Oscoda County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26137,
        "countyname": "Otsego County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26139,
        "countyname": "Ottawa County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26141,
        "countyname": "Presque Isle County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26143,
        "countyname": "Roscommon County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26145,
        "countyname": "Saginaw County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26147,
        "countyname": "St. Clair County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26149,
        "countyname": "St. Joseph County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26151,
        "countyname": "Sanilac County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26153,
        "countyname": "Schoolcraft County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26155,
        "countyname": "Shiawassee County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26157,
        "countyname": "Tuscola County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26159,
        "countyname": "Van Buren County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26161,
        "countyname": "Washtenaw County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26163,
        "countyname": "Wayne County",
        "stateorprovince": "MI"
    },
    {
        "fips": 26165,
        "countyname": "Wexford County",
        "stateorprovince": "MI"
    },
    {
        "fips": 27001,
        "countyname": "Aitkin County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27003,
        "countyname": "Anoka County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27005,
        "countyname": "Becker County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27007,
        "countyname": "Beltrami County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27009,
        "countyname": "Benton County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27011,
        "countyname": "Big Stone County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27013,
        "countyname": "Blue Earth County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27015,
        "countyname": "Brown County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27017,
        "countyname": "Carlton County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27019,
        "countyname": "Carver County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27021,
        "countyname": "Cass County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27023,
        "countyname": "Chippewa County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27025,
        "countyname": "Chisago County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27027,
        "countyname": "Clay County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27029,
        "countyname": "Clearwater County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27031,
        "countyname": "Cook County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27033,
        "countyname": "Cottonwood County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27035,
        "countyname": "Crow Wing County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27037,
        "countyname": "Dakota County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27039,
        "countyname": "Dodge County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27041,
        "countyname": "Douglas County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27043,
        "countyname": "Faribault County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27045,
        "countyname": "Fillmore County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27047,
        "countyname": "Freeborn County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27049,
        "countyname": "Goodhue County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27051,
        "countyname": "Grant County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27053,
        "countyname": "Hennepin County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27055,
        "countyname": "Houston County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27057,
        "countyname": "Hubbard County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27059,
        "countyname": "Isanti County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27061,
        "countyname": "Itasca County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27063,
        "countyname": "Jackson County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27065,
        "countyname": "Kanabec County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27067,
        "countyname": "Kandiyohi County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27069,
        "countyname": "Kittson County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27071,
        "countyname": "Koochiching County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27073,
        "countyname": "Lac qui Parle County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27075,
        "countyname": "Lake County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27077,
        "countyname": "Lake of the Woods County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27079,
        "countyname": "Le Sueur County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27081,
        "countyname": "Lincoln County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27083,
        "countyname": "Lyon County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27085,
        "countyname": "McLeod County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27087,
        "countyname": "Mahnomen County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27089,
        "countyname": "Marshall County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27091,
        "countyname": "Martin County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27093,
        "countyname": "Meeker County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27095,
        "countyname": "Mille Lacs County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27097,
        "countyname": "Morrison County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27099,
        "countyname": "Mower County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27101,
        "countyname": "Murray County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27103,
        "countyname": "Nicollet County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27105,
        "countyname": "Nobles County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27107,
        "countyname": "Norman County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27109,
        "countyname": "Olmsted County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27111,
        "countyname": "Otter Tail County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27113,
        "countyname": "Pennington County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27115,
        "countyname": "Pine County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27117,
        "countyname": "Pipestone County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27119,
        "countyname": "Polk County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27121,
        "countyname": "Pope County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27123,
        "countyname": "Ramsey County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27125,
        "countyname": "Red Lake County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27127,
        "countyname": "Redwood County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27129,
        "countyname": "Renville County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27131,
        "countyname": "Rice County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27133,
        "countyname": "Rock County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27135,
        "countyname": "Roseau County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27137,
        "countyname": "St. Louis County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27139,
        "countyname": "Scott County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27141,
        "countyname": "Sherburne County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27143,
        "countyname": "Sibley County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27145,
        "countyname": "Stearns County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27147,
        "countyname": "Steele County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27149,
        "countyname": "Stevens County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27151,
        "countyname": "Swift County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27153,
        "countyname": "Todd County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27155,
        "countyname": "Traverse County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27157,
        "countyname": "Wabasha County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27159,
        "countyname": "Wadena County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27161,
        "countyname": "Waseca County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27163,
        "countyname": "Washington County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27165,
        "countyname": "Watonwan County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27167,
        "countyname": "Wilkin County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27169,
        "countyname": "Winona County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27171,
        "countyname": "Wright County",
        "stateorprovince": "MN"
    },
    {
        "fips": 27173,
        "countyname": "Yellow Medicine County",
        "stateorprovince": "MN"
    },
    {
        "fips": 28001,
        "countyname": "Adams County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28003,
        "countyname": "Alcorn County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28005,
        "countyname": "Amite County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28007,
        "countyname": "Attala County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28009,
        "countyname": "Benton County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28011,
        "countyname": "Bolivar County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28013,
        "countyname": "Calhoun County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28015,
        "countyname": "Carroll County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28017,
        "countyname": "Chickasaw County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28019,
        "countyname": "Choctaw County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28021,
        "countyname": "Claiborne County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28023,
        "countyname": "Clarke County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28025,
        "countyname": "Clay County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28027,
        "countyname": "Coahoma County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28029,
        "countyname": "Copiah County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28031,
        "countyname": "Covington County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28033,
        "countyname": "De Soto County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28035,
        "countyname": "Forrest County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28037,
        "countyname": "Franklin County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28039,
        "countyname": "George County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28041,
        "countyname": "Greene County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28043,
        "countyname": "Grenada County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28045,
        "countyname": "Hancock County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28047,
        "countyname": "Harrison County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28049,
        "countyname": "Hinds County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28051,
        "countyname": "Holmes County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28053,
        "countyname": "Humphreys County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28055,
        "countyname": "Issaquena County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28057,
        "countyname": "Itawamba County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28059,
        "countyname": "Jackson County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28061,
        "countyname": "Jasper County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28063,
        "countyname": "Jefferson County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28065,
        "countyname": "Jefferson Davis County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28067,
        "countyname": "Jones County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28069,
        "countyname": "Kemper County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28071,
        "countyname": "Lafayette County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28073,
        "countyname": "Lamar County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28075,
        "countyname": "Lauderdale County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28077,
        "countyname": "Lawrence County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28079,
        "countyname": "Leake County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28081,
        "countyname": "Lee County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28083,
        "countyname": "Leflore County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28085,
        "countyname": "Lincoln County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28087,
        "countyname": "Lowndes County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28089,
        "countyname": "Madison County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28091,
        "countyname": "Marion County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28093,
        "countyname": "Marshall County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28095,
        "countyname": "Monroe County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28097,
        "countyname": "Montgomery County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28099,
        "countyname": "Neshoba County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28101,
        "countyname": "Newton County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28103,
        "countyname": "Noxubee County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28105,
        "countyname": "Oktibbeha County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28107,
        "countyname": "Panola County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28109,
        "countyname": "Pearl River County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28111,
        "countyname": "Perry County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28113,
        "countyname": "Pike County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28115,
        "countyname": "Pontotoc County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28117,
        "countyname": "Prentiss County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28119,
        "countyname": "Quitman County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28121,
        "countyname": "Rankin County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28123,
        "countyname": "Scott County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28125,
        "countyname": "Sharkey County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28127,
        "countyname": "Simpson County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28129,
        "countyname": "Smith County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28131,
        "countyname": "Stone County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28133,
        "countyname": "Sunflower County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28135,
        "countyname": "Tallahatchie County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28137,
        "countyname": "Tate County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28139,
        "countyname": "Tippah County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28141,
        "countyname": "Tishomingo County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28143,
        "countyname": "Tunica County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28145,
        "countyname": "Union County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28147,
        "countyname": "Walthall County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28149,
        "countyname": "Warren County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28151,
        "countyname": "Washington County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28153,
        "countyname": "Wayne County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28155,
        "countyname": "Webster County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28157,
        "countyname": "Wilkinson County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28159,
        "countyname": "Winston County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28161,
        "countyname": "Yalobusha County",
        "stateorprovince": "MS"
    },
    {
        "fips": 28163,
        "countyname": "Yazoo County",
        "stateorprovince": "MS"
    },
    {
        "fips": 29001,
        "countyname": "Adair County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29003,
        "countyname": "Andrew County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29005,
        "countyname": "Atchison County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29007,
        "countyname": "Audrain County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29009,
        "countyname": "Barry County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29011,
        "countyname": "Barton County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29013,
        "countyname": "Bates County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29015,
        "countyname": "Benton County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29017,
        "countyname": "Bollinger County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29019,
        "countyname": "Boone County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29021,
        "countyname": "Buchanan County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29023,
        "countyname": "Butler County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29025,
        "countyname": "Caldwell County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29027,
        "countyname": "Callaway County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29029,
        "countyname": "Camden County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29031,
        "countyname": "Cape Girardeau County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29033,
        "countyname": "Carroll County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29035,
        "countyname": "Carter County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29037,
        "countyname": "Cass County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29039,
        "countyname": "Cedar County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29041,
        "countyname": "Chariton County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29043,
        "countyname": "Christian County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29045,
        "countyname": "Clark County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29047,
        "countyname": "Clay County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29049,
        "countyname": "Clinton County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29051,
        "countyname": "Cole County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29053,
        "countyname": "Cooper County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29055,
        "countyname": "Crawford County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29057,
        "countyname": "Dade County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29059,
        "countyname": "Dallas County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29061,
        "countyname": "Daviess County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29063,
        "countyname": "DeKalb County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29065,
        "countyname": "Dent County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29067,
        "countyname": "Douglas County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29069,
        "countyname": "Dunklin County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29071,
        "countyname": "Franklin County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29073,
        "countyname": "Gasconade County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29075,
        "countyname": "Gentry County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29077,
        "countyname": "Greene County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29079,
        "countyname": "Grundy County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29081,
        "countyname": "Harrison County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29083,
        "countyname": "Henry County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29085,
        "countyname": "Hickory County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29087,
        "countyname": "Holt County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29089,
        "countyname": "Howard County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29091,
        "countyname": "Howell County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29093,
        "countyname": "Iron County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29095,
        "countyname": "Jackson County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29097,
        "countyname": "Jasper County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29099,
        "countyname": "Jefferson County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29101,
        "countyname": "Johnson County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29103,
        "countyname": "Knox County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29105,
        "countyname": "Laclede County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29107,
        "countyname": "Lafayette County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29109,
        "countyname": "Lawrence County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29111,
        "countyname": "Lewis County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29113,
        "countyname": "Lincoln County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29115,
        "countyname": "Linn County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29117,
        "countyname": "Livingston County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29119,
        "countyname": "McDonald County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29121,
        "countyname": "Macon County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29123,
        "countyname": "Madison County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29125,
        "countyname": "Maries County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29127,
        "countyname": "Marion County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29129,
        "countyname": "Mercer County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29131,
        "countyname": "Miller County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29133,
        "countyname": "Mississippi County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29135,
        "countyname": "Moniteau County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29137,
        "countyname": "Monroe County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29139,
        "countyname": "Montgomery County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29141,
        "countyname": "Morgan County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29143,
        "countyname": "New Madrid County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29145,
        "countyname": "Newton County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29147,
        "countyname": "Nodaway County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29149,
        "countyname": "Oregon County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29151,
        "countyname": "Osage County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29153,
        "countyname": "Ozark County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29155,
        "countyname": "Pemiscot County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29157,
        "countyname": "Perry County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29159,
        "countyname": "Pettis County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29161,
        "countyname": "Phelps County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29163,
        "countyname": "Pike County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29165,
        "countyname": "Platte County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29167,
        "countyname": "Polk County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29169,
        "countyname": "Pulaski County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29171,
        "countyname": "Putnam County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29173,
        "countyname": "Ralls County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29175,
        "countyname": "Randolph County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29177,
        "countyname": "Ray County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29179,
        "countyname": "Reynolds County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29181,
        "countyname": "Ripley County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29183,
        "countyname": "St. Charles County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29185,
        "countyname": "St. Clair County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29186,
        "countyname": "Ste. Genevieve County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29187,
        "countyname": "St. Francois County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29189,
        "countyname": "St. Louis County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29195,
        "countyname": "Saline County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29197,
        "countyname": "Schuyler County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29199,
        "countyname": "Scotland County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29201,
        "countyname": "Scott County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29203,
        "countyname": "Shannon County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29205,
        "countyname": "Shelby County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29207,
        "countyname": "Stoddard County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29209,
        "countyname": "Stone County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29211,
        "countyname": "Sullivan County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29213,
        "countyname": "Taney County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29215,
        "countyname": "Texas County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29217,
        "countyname": "Vernon County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29219,
        "countyname": "Warren County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29221,
        "countyname": "Washington County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29223,
        "countyname": "Wayne County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29225,
        "countyname": "Webster County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29227,
        "countyname": "Worth County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29229,
        "countyname": "Wright County",
        "stateorprovince": "MO"
    },
    {
        "fips": 29510,
        "countyname": "St. Louis city",
        "stateorprovince": "MO"
    },
    {
        "fips": 30001,
        "countyname": "Beaverhead County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30003,
        "countyname": "Big Horn County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30005,
        "countyname": "Blaine County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30007,
        "countyname": "Broadwater County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30009,
        "countyname": "Carbon County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30011,
        "countyname": "Carter County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30013,
        "countyname": "Cascade County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30015,
        "countyname": "Chouteau County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30017,
        "countyname": "Custer County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30019,
        "countyname": "Daniels County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30021,
        "countyname": "Dawson County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30023,
        "countyname": "Deer Lodge County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30025,
        "countyname": "Fallon County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30027,
        "countyname": "Fergus County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30029,
        "countyname": "Flathead County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30031,
        "countyname": "Gallatin County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30033,
        "countyname": "Garfield County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30035,
        "countyname": "Glacier County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30037,
        "countyname": "Golden Valley County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30039,
        "countyname": "Granite County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30041,
        "countyname": "Hill County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30043,
        "countyname": "Jefferson County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30045,
        "countyname": "Judith Basin County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30047,
        "countyname": "Lake County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30049,
        "countyname": "Lewis and Clark County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30051,
        "countyname": "Liberty County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30053,
        "countyname": "Lincoln County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30055,
        "countyname": "McCone County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30057,
        "countyname": "Madison County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30059,
        "countyname": "Meagher County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30061,
        "countyname": "Mineral County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30063,
        "countyname": "Missoula County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30065,
        "countyname": "Musselshell County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30067,
        "countyname": "Park County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30069,
        "countyname": "Petroleum County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30071,
        "countyname": "Phillips County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30073,
        "countyname": "Pondera County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30075,
        "countyname": "Powder River County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30077,
        "countyname": "Powell County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30079,
        "countyname": "Prairie County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30081,
        "countyname": "Ravalli County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30083,
        "countyname": "Richland County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30085,
        "countyname": "Roosevelt County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30087,
        "countyname": "Rosebud County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30089,
        "countyname": "Sanders County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30091,
        "countyname": "Sheridan County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30093,
        "countyname": "Silver Bow County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30095,
        "countyname": "Stillwater County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30097,
        "countyname": "Sweet Grass County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30099,
        "countyname": "Teton County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30101,
        "countyname": "Toole County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30103,
        "countyname": "Treasure County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30105,
        "countyname": "Valley County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30107,
        "countyname": "Wheatland County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30109,
        "countyname": "Wibaux County",
        "stateorprovince": "MT"
    },
    {
        "fips": 30111,
        "countyname": "Yellowstone County",
        "stateorprovince": "MT"
    },
    {
        "fips": 31001,
        "countyname": "Adams County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31003,
        "countyname": "Antelope County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31005,
        "countyname": "Arthur County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31007,
        "countyname": "Banner County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31009,
        "countyname": "Blaine County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31011,
        "countyname": "Boone County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31013,
        "countyname": "Box Butte County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31015,
        "countyname": "Boyd County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31017,
        "countyname": "Brown County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31019,
        "countyname": "Buffalo County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31021,
        "countyname": "Burt County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31023,
        "countyname": "Butler County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31025,
        "countyname": "Cass County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31027,
        "countyname": "Cedar County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31029,
        "countyname": "Chase County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31031,
        "countyname": "Cherry County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31033,
        "countyname": "Cheyenne County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31035,
        "countyname": "Clay County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31037,
        "countyname": "Colfax County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31039,
        "countyname": "Cuming County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31041,
        "countyname": "Custer County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31043,
        "countyname": "Dakota County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31045,
        "countyname": "Dawes County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31047,
        "countyname": "Dawson County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31049,
        "countyname": "Deuel County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31051,
        "countyname": "Dixon County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31053,
        "countyname": "Dodge County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31055,
        "countyname": "Douglas County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31057,
        "countyname": "Dundy County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31059,
        "countyname": "Fillmore County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31061,
        "countyname": "Franklin County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31063,
        "countyname": "Frontier County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31065,
        "countyname": "Furnas County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31067,
        "countyname": "Gage County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31069,
        "countyname": "Garden County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31071,
        "countyname": "Garfield County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31073,
        "countyname": "Gosper County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31075,
        "countyname": "Grant County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31077,
        "countyname": "Greeley County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31079,
        "countyname": "Hall County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31081,
        "countyname": "Hamilton County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31083,
        "countyname": "Harlan County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31085,
        "countyname": "Hayes County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31087,
        "countyname": "Hitchcock County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31089,
        "countyname": "Holt County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31091,
        "countyname": "Hooker County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31093,
        "countyname": "Howard County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31095,
        "countyname": "Jefferson County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31097,
        "countyname": "Johnson County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31099,
        "countyname": "Kearney County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31101,
        "countyname": "Keith County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31103,
        "countyname": "Keya Paha County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31105,
        "countyname": "Kimball County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31107,
        "countyname": "Knox County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31109,
        "countyname": "Lancaster County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31111,
        "countyname": "Lincoln County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31113,
        "countyname": "Logan County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31115,
        "countyname": "Loup County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31117,
        "countyname": "McPherson County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31119,
        "countyname": "Madison County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31121,
        "countyname": "Merrick County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31123,
        "countyname": "Morrill County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31125,
        "countyname": "Nance County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31127,
        "countyname": "Nemaha County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31129,
        "countyname": "Nuckolls County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31131,
        "countyname": "Otoe County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31133,
        "countyname": "Pawnee County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31135,
        "countyname": "Perkins County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31137,
        "countyname": "Phelps County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31139,
        "countyname": "Pierce County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31141,
        "countyname": "Platte County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31143,
        "countyname": "Polk County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31145,
        "countyname": "Red Willow County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31147,
        "countyname": "Richardson County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31149,
        "countyname": "Rock County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31151,
        "countyname": "Saline County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31153,
        "countyname": "Sarpy County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31155,
        "countyname": "Saunders County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31157,
        "countyname": "Scotts Bluff County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31159,
        "countyname": "Seward County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31161,
        "countyname": "Sheridan County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31163,
        "countyname": "Sherman County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31165,
        "countyname": "Sioux County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31167,
        "countyname": "Stanton County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31169,
        "countyname": "Thayer County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31171,
        "countyname": "Thomas County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31173,
        "countyname": "Thurston County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31175,
        "countyname": "Valley County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31177,
        "countyname": "Washington County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31179,
        "countyname": "Wayne County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31181,
        "countyname": "Webster County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31183,
        "countyname": "Wheeler County",
        "stateorprovince": "NE"
    },
    {
        "fips": 31185,
        "countyname": "York County",
        "stateorprovince": "NE"
    },
    {
        "fips": 32001,
        "countyname": "Churchill County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32003,
        "countyname": "Clark County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32005,
        "countyname": "Douglas County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32007,
        "countyname": "Elko County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32009,
        "countyname": "Esmeralda County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32011,
        "countyname": "Eureka County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32013,
        "countyname": "Humboldt County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32015,
        "countyname": "Lander County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32017,
        "countyname": "Lincoln County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32019,
        "countyname": "Lyon County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32021,
        "countyname": "Mineral County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32023,
        "countyname": "Nye County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32027,
        "countyname": "Pershing County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32029,
        "countyname": "Storey County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32031,
        "countyname": "Washoe County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32033,
        "countyname": "White Pine County",
        "stateorprovince": "NV"
    },
    {
        "fips": 32510,
        "countyname": "Carson City",
        "stateorprovince": "NV"
    },
    {
        "fips": 33001,
        "countyname": "Belknap County",
        "stateorprovince": "NH"
    },
    {
        "fips": 33003,
        "countyname": "Carroll County",
        "stateorprovince": "NH"
    },
    {
        "fips": 33005,
        "countyname": "Cheshire County",
        "stateorprovince": "NH"
    },
    {
        "fips": 33007,
        "countyname": "Coos County",
        "stateorprovince": "NH"
    },
    {
        "fips": 33009,
        "countyname": "Grafton County",
        "stateorprovince": "NH"
    },
    {
        "fips": 33011,
        "countyname": "Hillsborough County",
        "stateorprovince": "NH"
    },
    {
        "fips": 33013,
        "countyname": "Merrimack County",
        "stateorprovince": "NH"
    },
    {
        "fips": 33015,
        "countyname": "Rockingham County",
        "stateorprovince": "NH"
    },
    {
        "fips": 33017,
        "countyname": "Strafford County",
        "stateorprovince": "NH"
    },
    {
        "fips": 33019,
        "countyname": "Sullivan County",
        "stateorprovince": "NH"
    },
    {
        "fips": 34001,
        "countyname": "Atlantic County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34003,
        "countyname": "Bergen County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34005,
        "countyname": "Burlington County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34007,
        "countyname": "Camden County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34009,
        "countyname": "Cape May County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34011,
        "countyname": "Cumberland County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34013,
        "countyname": "Essex County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34015,
        "countyname": "Gloucester County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34017,
        "countyname": "Hudson County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34019,
        "countyname": "Hunterdon County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34021,
        "countyname": "Mercer County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34023,
        "countyname": "Middlesex County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34025,
        "countyname": "Monmouth County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34027,
        "countyname": "Morris County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34029,
        "countyname": "Ocean County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34031,
        "countyname": "Passaic County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34033,
        "countyname": "Salem County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34035,
        "countyname": "Somerset County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34037,
        "countyname": "Sussex County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34039,
        "countyname": "Union County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 34041,
        "countyname": "Warren County",
        "stateorprovince": "NJ"
    },
    {
        "fips": 35001,
        "countyname": "Bernalillo County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35003,
        "countyname": "Catron County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35005,
        "countyname": "Chaves County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35006,
        "countyname": "Cibola County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35007,
        "countyname": "Colfax County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35009,
        "countyname": "Curry County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35011,
        "countyname": "DeBaca County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35013,
        "countyname": "Dona Ana County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35015,
        "countyname": "Eddy County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35017,
        "countyname": "Grant County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35019,
        "countyname": "Guadalupe County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35021,
        "countyname": "Harding County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35023,
        "countyname": "Hidalgo County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35025,
        "countyname": "Lea County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35027,
        "countyname": "Lincoln County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35028,
        "countyname": "Los Alamos County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35029,
        "countyname": "Luna County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35031,
        "countyname": "McKinley County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35033,
        "countyname": "Mora County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35035,
        "countyname": "Otero County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35037,
        "countyname": "Quay County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35039,
        "countyname": "Rio Arriba County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35041,
        "countyname": "Roosevelt County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35043,
        "countyname": "Sandoval County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35045,
        "countyname": "San Juan County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35047,
        "countyname": "San Miguel County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35049,
        "countyname": "Santa Fe County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35051,
        "countyname": "Sierra County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35053,
        "countyname": "Socorro County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35055,
        "countyname": "Taos County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35057,
        "countyname": "Torrance County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35059,
        "countyname": "Union County",
        "stateorprovince": "NM"
    },
    {
        "fips": 35061,
        "countyname": "Valencia County",
        "stateorprovince": "NM"
    },
    {
        "fips": 36001,
        "countyname": "Albany County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36003,
        "countyname": "Allegany County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36005,
        "countyname": "Bronx County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36007,
        "countyname": "Broome County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36009,
        "countyname": "Cattaraugus County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36011,
        "countyname": "Cayuga County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36013,
        "countyname": "Chautauqua County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36015,
        "countyname": "Chemung County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36017,
        "countyname": "Chenango County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36019,
        "countyname": "Clinton County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36021,
        "countyname": "Columbia County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36023,
        "countyname": "Cortland County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36025,
        "countyname": "Delaware County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36027,
        "countyname": "Dutchess County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36029,
        "countyname": "Erie County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36031,
        "countyname": "Essex County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36033,
        "countyname": "Franklin County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36035,
        "countyname": "Fulton County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36037,
        "countyname": "Genesee County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36039,
        "countyname": "Greene County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36041,
        "countyname": "Hamilton County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36043,
        "countyname": "Herkimer County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36045,
        "countyname": "Jefferson County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36047,
        "countyname": "Kings County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36049,
        "countyname": "Lewis County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36051,
        "countyname": "Livingston County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36053,
        "countyname": "Madison County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36055,
        "countyname": "Monroe County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36057,
        "countyname": "Montgomery County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36059,
        "countyname": "Nassau County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36061,
        "countyname": "New York County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36063,
        "countyname": "Niagara County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36065,
        "countyname": "Oneida County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36067,
        "countyname": "Onondaga County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36069,
        "countyname": "Ontario County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36071,
        "countyname": "Orange County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36073,
        "countyname": "Orleans County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36075,
        "countyname": "Oswego County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36077,
        "countyname": "Otsego County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36079,
        "countyname": "Putnam County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36081,
        "countyname": "Queens County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36083,
        "countyname": "Rensselaer County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36085,
        "countyname": "Richmond County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36087,
        "countyname": "Rockland County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36089,
        "countyname": "St. Lawrence County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36091,
        "countyname": "Saratoga County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36093,
        "countyname": "Schenectady County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36095,
        "countyname": "Schoharie County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36097,
        "countyname": "Schuyler County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36099,
        "countyname": "Seneca County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36101,
        "countyname": "Steuben County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36103,
        "countyname": "Suffolk County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36105,
        "countyname": "Sullivan County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36107,
        "countyname": "Tioga County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36109,
        "countyname": "Tompkins County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36111,
        "countyname": "Ulster County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36113,
        "countyname": "Warren County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36115,
        "countyname": "Washington County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36117,
        "countyname": "Wayne County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36119,
        "countyname": "Westchester County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36121,
        "countyname": "Wyoming County",
        "stateorprovince": "NY"
    },
    {
        "fips": 36123,
        "countyname": "Yates County",
        "stateorprovince": "NY"
    },
    {
        "fips": 37001,
        "countyname": "Alamance County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37003,
        "countyname": "Alexander County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37005,
        "countyname": "Alleghany County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37007,
        "countyname": "Anson County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37009,
        "countyname": "Ashe County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37011,
        "countyname": "Avery County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37013,
        "countyname": "Beaufort County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37015,
        "countyname": "Bertie County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37017,
        "countyname": "Bladen County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37019,
        "countyname": "Brunswick County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37021,
        "countyname": "Buncombe County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37023,
        "countyname": "Burke County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37025,
        "countyname": "Cabarrus County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37027,
        "countyname": "Caldwell County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37029,
        "countyname": "Camden County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37031,
        "countyname": "Carteret County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37033,
        "countyname": "Caswell County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37035,
        "countyname": "Catawba County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37037,
        "countyname": "Chatham County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37039,
        "countyname": "Cherokee County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37041,
        "countyname": "Chowan County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37043,
        "countyname": "Clay County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37045,
        "countyname": "Cleveland County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37047,
        "countyname": "Columbus County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37049,
        "countyname": "Craven County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37051,
        "countyname": "Cumberland County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37053,
        "countyname": "Currituck County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37055,
        "countyname": "Dare County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37057,
        "countyname": "Davidson County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37059,
        "countyname": "Davie County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37061,
        "countyname": "Duplin County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37063,
        "countyname": "Durham County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37065,
        "countyname": "Edgecombe County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37067,
        "countyname": "Forsyth County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37069,
        "countyname": "Franklin County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37071,
        "countyname": "Gaston County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37073,
        "countyname": "Gates County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37075,
        "countyname": "Graham County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37077,
        "countyname": "Granville County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37079,
        "countyname": "Greene County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37081,
        "countyname": "Guilford County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37083,
        "countyname": "Halifax County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37085,
        "countyname": "Harnett County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37087,
        "countyname": "Haywood County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37089,
        "countyname": "Henderson County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37091,
        "countyname": "Hertford County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37093,
        "countyname": "Hoke County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37095,
        "countyname": "Hyde County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37097,
        "countyname": "Iredell County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37099,
        "countyname": "Jackson County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37101,
        "countyname": "Johnston County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37103,
        "countyname": "Jones County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37105,
        "countyname": "Lee County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37107,
        "countyname": "Lenoir County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37109,
        "countyname": "Lincoln County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37111,
        "countyname": "McDowell County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37113,
        "countyname": "Macon County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37115,
        "countyname": "Madison County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37117,
        "countyname": "Martin County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37119,
        "countyname": "Mecklenburg County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37121,
        "countyname": "Mitchell County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37123,
        "countyname": "Montgomery County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37125,
        "countyname": "Moore County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37127,
        "countyname": "Nash County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37129,
        "countyname": "New Hanover County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37131,
        "countyname": "Northampton County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37133,
        "countyname": "Onslow County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37135,
        "countyname": "Orange County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37137,
        "countyname": "Pamlico County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37139,
        "countyname": "Pasquotank County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37141,
        "countyname": "Pender County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37143,
        "countyname": "Perquimans County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37145,
        "countyname": "Person County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37147,
        "countyname": "Pitt County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37149,
        "countyname": "Polk County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37151,
        "countyname": "Randolph County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37153,
        "countyname": "Richmond County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37155,
        "countyname": "Robeson County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37157,
        "countyname": "Rockingham County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37159,
        "countyname": "Rowan County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37161,
        "countyname": "Rutherford County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37163,
        "countyname": "Sampson County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37165,
        "countyname": "Scotland County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37167,
        "countyname": "Stanly County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37169,
        "countyname": "Stokes County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37171,
        "countyname": "Surry County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37173,
        "countyname": "Swain County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37175,
        "countyname": "Transylvania County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37177,
        "countyname": "Tyrrell County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37179,
        "countyname": "Union County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37181,
        "countyname": "Vance County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37183,
        "countyname": "Wake County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37185,
        "countyname": "Warren County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37187,
        "countyname": "Washington County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37189,
        "countyname": "Watauga County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37191,
        "countyname": "Wayne County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37193,
        "countyname": "Wilkes County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37195,
        "countyname": "Wilson County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37197,
        "countyname": "Yadkin County",
        "stateorprovince": "NC"
    },
    {
        "fips": 37199,
        "countyname": "Yancey County",
        "stateorprovince": "NC"
    },
    {
        "fips": 38001,
        "countyname": "Adams County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38003,
        "countyname": "Barnes County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38005,
        "countyname": "Benson County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38007,
        "countyname": "Billings County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38009,
        "countyname": "Bottineau County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38011,
        "countyname": "Bowman County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38013,
        "countyname": "Burke County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38015,
        "countyname": "Burleigh County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38017,
        "countyname": "Cass County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38019,
        "countyname": "Cavalier County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38021,
        "countyname": "Dickey County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38023,
        "countyname": "Divide County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38025,
        "countyname": "Dunn County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38027,
        "countyname": "Eddy County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38029,
        "countyname": "Emmons County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38031,
        "countyname": "Foster County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38033,
        "countyname": "Golden Valley County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38035,
        "countyname": "Grand Forks County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38037,
        "countyname": "Grant County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38039,
        "countyname": "Griggs County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38041,
        "countyname": "Hettinger County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38043,
        "countyname": "Kidder County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38045,
        "countyname": "LaMoure County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38047,
        "countyname": "Logan County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38049,
        "countyname": "McHenry County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38051,
        "countyname": "McIntosh County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38053,
        "countyname": "McKenzie County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38055,
        "countyname": "McLean County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38057,
        "countyname": "Mercer County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38059,
        "countyname": "Morton County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38061,
        "countyname": "Mountrail County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38063,
        "countyname": "Nelson County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38065,
        "countyname": "Oliver County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38067,
        "countyname": "Pembina County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38069,
        "countyname": "Pierce County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38071,
        "countyname": "Ramsey County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38073,
        "countyname": "Ransom County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38075,
        "countyname": "Renville County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38077,
        "countyname": "Richland County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38079,
        "countyname": "Rolette County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38081,
        "countyname": "Sargent County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38083,
        "countyname": "Sheridan County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38085,
        "countyname": "Sioux County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38087,
        "countyname": "Slope County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38089,
        "countyname": "Stark County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38091,
        "countyname": "Steele County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38093,
        "countyname": "Stutsman County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38095,
        "countyname": "Towner County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38097,
        "countyname": "Traill County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38099,
        "countyname": "Walsh County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38101,
        "countyname": "Ward County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38103,
        "countyname": "Wells County",
        "stateorprovince": "ND"
    },
    {
        "fips": 38105,
        "countyname": "Williams County",
        "stateorprovince": "ND"
    },
    {
        "fips": 39001,
        "countyname": "Adams County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39003,
        "countyname": "Allen County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39005,
        "countyname": "Ashland County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39007,
        "countyname": "Ashtabula County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39009,
        "countyname": "Athens County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39011,
        "countyname": "Auglaize County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39013,
        "countyname": "Belmont County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39015,
        "countyname": "Brown County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39017,
        "countyname": "Butler County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39019,
        "countyname": "Carroll County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39021,
        "countyname": "Champaign County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39023,
        "countyname": "Clark County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39025,
        "countyname": "Clermont County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39027,
        "countyname": "Clinton County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39029,
        "countyname": "Columbiana County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39031,
        "countyname": "Coshocton County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39033,
        "countyname": "Crawford County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39035,
        "countyname": "Cuyahoga County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39037,
        "countyname": "Darke County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39039,
        "countyname": "Defiance County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39041,
        "countyname": "Delaware County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39043,
        "countyname": "Erie County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39045,
        "countyname": "Fairfield County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39047,
        "countyname": "Fayette County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39049,
        "countyname": "Franklin County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39051,
        "countyname": "Fulton County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39053,
        "countyname": "Gallia County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39055,
        "countyname": "Geauga County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39057,
        "countyname": "Greene County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39059,
        "countyname": "Guernsey County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39061,
        "countyname": "Hamilton County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39063,
        "countyname": "Hancock County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39065,
        "countyname": "Hardin County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39067,
        "countyname": "Harrison County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39069,
        "countyname": "Henry County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39071,
        "countyname": "Highland County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39073,
        "countyname": "Hocking County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39075,
        "countyname": "Holmes County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39077,
        "countyname": "Huron County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39079,
        "countyname": "Jackson County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39081,
        "countyname": "Jefferson County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39083,
        "countyname": "Knox County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39085,
        "countyname": "Lake County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39087,
        "countyname": "Lawrence County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39089,
        "countyname": "Licking County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39091,
        "countyname": "Logan County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39093,
        "countyname": "Lorain County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39095,
        "countyname": "Lucas County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39097,
        "countyname": "Madison County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39099,
        "countyname": "Mahoning County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39101,
        "countyname": "Marion County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39103,
        "countyname": "Medina County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39105,
        "countyname": "Meigs County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39107,
        "countyname": "Mercer County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39109,
        "countyname": "Miami County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39111,
        "countyname": "Monroe County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39113,
        "countyname": "Montgomery County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39115,
        "countyname": "Morgan County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39117,
        "countyname": "Morrow County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39119,
        "countyname": "Muskingum County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39121,
        "countyname": "Noble County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39123,
        "countyname": "Ottawa County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39125,
        "countyname": "Paulding County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39127,
        "countyname": "Perry County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39129,
        "countyname": "Pickaway County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39131,
        "countyname": "Pike County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39133,
        "countyname": "Portage County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39135,
        "countyname": "Preble County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39137,
        "countyname": "Putnam County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39139,
        "countyname": "Richland County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39141,
        "countyname": "Ross County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39143,
        "countyname": "Sandusky County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39145,
        "countyname": "Scioto County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39147,
        "countyname": "Seneca County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39149,
        "countyname": "Shelby County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39151,
        "countyname": "Stark County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39153,
        "countyname": "Summit County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39155,
        "countyname": "Trumbull County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39157,
        "countyname": "Tuscarawas County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39159,
        "countyname": "Union County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39161,
        "countyname": "Van Wert County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39163,
        "countyname": "Vinton County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39165,
        "countyname": "Warren County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39167,
        "countyname": "Washington County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39169,
        "countyname": "Wayne County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39171,
        "countyname": "Williams County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39173,
        "countyname": "Wood County",
        "stateorprovince": "OH"
    },
    {
        "fips": 39175,
        "countyname": "Wyandot County",
        "stateorprovince": "OH"
    },
    {
        "fips": 40001,
        "countyname": "Adair County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40003,
        "countyname": "Alfalfa County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40005,
        "countyname": "Atoka County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40007,
        "countyname": "Beaver County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40009,
        "countyname": "Beckham County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40011,
        "countyname": "Blaine County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40013,
        "countyname": "Bryan County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40015,
        "countyname": "Caddo County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40017,
        "countyname": "Canadian County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40019,
        "countyname": "Carter County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40021,
        "countyname": "Cherokee County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40023,
        "countyname": "Choctaw County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40025,
        "countyname": "Cimarron County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40027,
        "countyname": "Cleveland County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40029,
        "countyname": "Coal County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40031,
        "countyname": "Comanche County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40033,
        "countyname": "Cotton County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40035,
        "countyname": "Craig County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40037,
        "countyname": "Creek County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40039,
        "countyname": "Custer County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40041,
        "countyname": "Delaware County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40043,
        "countyname": "Dewey County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40045,
        "countyname": "Ellis County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40047,
        "countyname": "Garfield County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40049,
        "countyname": "Garvin County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40051,
        "countyname": "Grady County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40053,
        "countyname": "Grant County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40055,
        "countyname": "Greer County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40057,
        "countyname": "Harmon County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40059,
        "countyname": "Harper County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40061,
        "countyname": "Haskell County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40063,
        "countyname": "Hughes County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40065,
        "countyname": "Jackson County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40067,
        "countyname": "Jefferson County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40069,
        "countyname": "Johnston County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40071,
        "countyname": "Kay County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40073,
        "countyname": "Kingfisher County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40075,
        "countyname": "Kiowa County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40077,
        "countyname": "Latimer County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40079,
        "countyname": "Le Flore County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40081,
        "countyname": "Lincoln County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40083,
        "countyname": "Logan County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40085,
        "countyname": "Love County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40087,
        "countyname": "McClain County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40089,
        "countyname": "McCurtain County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40091,
        "countyname": "McIntosh County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40093,
        "countyname": "Major County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40095,
        "countyname": "Marshall County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40097,
        "countyname": "Mayes County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40099,
        "countyname": "Murray County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40101,
        "countyname": "Muskogee County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40103,
        "countyname": "Noble County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40105,
        "countyname": "Nowata County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40107,
        "countyname": "Okfuskee County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40109,
        "countyname": "Oklahoma County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40111,
        "countyname": "Okmulgee County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40113,
        "countyname": "Osage County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40115,
        "countyname": "Ottawa County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40117,
        "countyname": "Pawnee County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40119,
        "countyname": "Payne County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40121,
        "countyname": "Pittsburg County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40123,
        "countyname": "Pontotoc County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40125,
        "countyname": "Pottawatomie County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40127,
        "countyname": "Pushmataha County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40129,
        "countyname": "Roger Mills County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40131,
        "countyname": "Rogers County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40133,
        "countyname": "Seminole County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40135,
        "countyname": "Sequoyah County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40137,
        "countyname": "Stephens County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40139,
        "countyname": "Texas County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40141,
        "countyname": "Tillman County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40143,
        "countyname": "Tulsa County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40145,
        "countyname": "Wagoner County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40147,
        "countyname": "Washington County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40149,
        "countyname": "Washita County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40151,
        "countyname": "Woods County",
        "stateorprovince": "OK"
    },
    {
        "fips": 40153,
        "countyname": "Woodward County",
        "stateorprovince": "OK"
    },
    {
        "fips": 41001,
        "countyname": "Baker County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41003,
        "countyname": "Benton County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41005,
        "countyname": "Clackamas County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41007,
        "countyname": "Clatsop County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41009,
        "countyname": "Columbia County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41011,
        "countyname": "Coos County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41013,
        "countyname": "Crook County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41015,
        "countyname": "Curry County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41017,
        "countyname": "Deschutes County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41019,
        "countyname": "Douglas County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41021,
        "countyname": "Gilliam County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41023,
        "countyname": "Grant County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41025,
        "countyname": "Harney County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41027,
        "countyname": "Hood River County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41029,
        "countyname": "Jackson County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41031,
        "countyname": "Jefferson County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41033,
        "countyname": "Josephine County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41035,
        "countyname": "Klamath County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41037,
        "countyname": "Lake County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41039,
        "countyname": "Lane County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41041,
        "countyname": "Lincoln County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41043,
        "countyname": "Linn County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41045,
        "countyname": "Malheur County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41047,
        "countyname": "Marion County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41049,
        "countyname": "Morrow County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41051,
        "countyname": "Multnomah County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41053,
        "countyname": "Polk County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41055,
        "countyname": "Sherman County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41057,
        "countyname": "Tillamook County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41059,
        "countyname": "Umatilla County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41061,
        "countyname": "Union County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41063,
        "countyname": "Wallowa County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41065,
        "countyname": "Wasco County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41067,
        "countyname": "Washington County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41069,
        "countyname": "Wheeler County",
        "stateorprovince": "OR"
    },
    {
        "fips": 41071,
        "countyname": "Yamhill County",
        "stateorprovince": "OR"
    },
    {
        "fips": 42001,
        "countyname": "Adams County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42003,
        "countyname": "Allegheny County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42005,
        "countyname": "Armstrong County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42007,
        "countyname": "Beaver County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42009,
        "countyname": "Bedford County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42011,
        "countyname": "Berks County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42013,
        "countyname": "Blair County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42015,
        "countyname": "Bradford County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42017,
        "countyname": "Bucks County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42019,
        "countyname": "Butler County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42021,
        "countyname": "Cambria County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42023,
        "countyname": "Cameron County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42025,
        "countyname": "Carbon County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42027,
        "countyname": "Centre County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42029,
        "countyname": "Chester County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42031,
        "countyname": "Clarion County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42033,
        "countyname": "Clearfield County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42035,
        "countyname": "Clinton County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42037,
        "countyname": "Columbia County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42039,
        "countyname": "Crawford County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42041,
        "countyname": "Cumberland County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42043,
        "countyname": "Dauphin County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42045,
        "countyname": "Delaware County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42047,
        "countyname": "Elk County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42049,
        "countyname": "Erie County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42051,
        "countyname": "Fayette County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42053,
        "countyname": "Forest County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42055,
        "countyname": "Franklin County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42057,
        "countyname": "Fulton County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42059,
        "countyname": "Greene County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42061,
        "countyname": "Huntingdon County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42063,
        "countyname": "Indiana County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42065,
        "countyname": "Jefferson County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42067,
        "countyname": "Juniata County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42069,
        "countyname": "Lackawanna County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42071,
        "countyname": "Lancaster County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42073,
        "countyname": "Lawrence County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42075,
        "countyname": "Lebanon County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42077,
        "countyname": "Lehigh County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42079,
        "countyname": "Luzerne County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42081,
        "countyname": "Lycoming County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42083,
        "countyname": "Mc Kean County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42085,
        "countyname": "Mercer County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42087,
        "countyname": "Mifflin County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42089,
        "countyname": "Monroe County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42091,
        "countyname": "Montgomery County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42093,
        "countyname": "Montour County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42095,
        "countyname": "Northampton County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42097,
        "countyname": "Northumberland County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42099,
        "countyname": "Perry County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42101,
        "countyname": "Philadelphia County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42103,
        "countyname": "Pike County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42105,
        "countyname": "Potter County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42107,
        "countyname": "Schuylkill County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42109,
        "countyname": "Snyder County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42111,
        "countyname": "Somerset County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42113,
        "countyname": "Sullivan County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42115,
        "countyname": "Susquehanna County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42117,
        "countyname": "Tioga County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42119,
        "countyname": "Union County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42121,
        "countyname": "Venango County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42123,
        "countyname": "Warren County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42125,
        "countyname": "Washington County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42127,
        "countyname": "Wayne County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42129,
        "countyname": "Westmoreland County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42131,
        "countyname": "Wyoming County",
        "stateorprovince": "PA"
    },
    {
        "fips": 42133,
        "countyname": "York County",
        "stateorprovince": "PA"
    },
    {
        "fips": 44001,
        "countyname": "Bristol County",
        "stateorprovince": "RI"
    },
    {
        "fips": 44003,
        "countyname": "Kent County",
        "stateorprovince": "RI"
    },
    {
        "fips": 44005,
        "countyname": "Newport County",
        "stateorprovince": "RI"
    },
    {
        "fips": 44007,
        "countyname": "Providence County",
        "stateorprovince": "RI"
    },
    {
        "fips": 44009,
        "countyname": "Washington County",
        "stateorprovince": "RI"
    },
    {
        "fips": 45001,
        "countyname": "Abbeville County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45003,
        "countyname": "Aiken County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45005,
        "countyname": "Allendale County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45007,
        "countyname": "Anderson County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45009,
        "countyname": "Bamberg County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45011,
        "countyname": "Barnwell County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45013,
        "countyname": "Beaufort County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45015,
        "countyname": "Berkeley County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45017,
        "countyname": "Calhoun County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45019,
        "countyname": "Charleston County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45021,
        "countyname": "Cherokee County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45023,
        "countyname": "Chester County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45025,
        "countyname": "Chesterfield County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45027,
        "countyname": "Clarendon County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45029,
        "countyname": "Colleton County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45031,
        "countyname": "Darlington County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45033,
        "countyname": "Dillon County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45035,
        "countyname": "Dorchester County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45037,
        "countyname": "Edgefield County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45039,
        "countyname": "Fairfield County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45041,
        "countyname": "Florence County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45043,
        "countyname": "Georgetown County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45045,
        "countyname": "Greenville County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45047,
        "countyname": "Greenwood County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45049,
        "countyname": "Hampton County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45051,
        "countyname": "Horry County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45053,
        "countyname": "Jasper County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45055,
        "countyname": "Kershaw County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45057,
        "countyname": "Lancaster County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45059,
        "countyname": "Laurens County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45061,
        "countyname": "Lee County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45063,
        "countyname": "Lexington County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45065,
        "countyname": "McCormick County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45067,
        "countyname": "Marion County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45069,
        "countyname": "Marlboro County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45071,
        "countyname": "Newberry County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45073,
        "countyname": "Oconee County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45075,
        "countyname": "Orangeburg County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45077,
        "countyname": "Pickens County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45079,
        "countyname": "Richland County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45081,
        "countyname": "Saluda County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45083,
        "countyname": "Spartanburg County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45085,
        "countyname": "Sumter County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45087,
        "countyname": "Union County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45089,
        "countyname": "Williamsburg County",
        "stateorprovince": "SC"
    },
    {
        "fips": 45091,
        "countyname": "York County",
        "stateorprovince": "SC"
    },
    {
        "fips": 46003,
        "countyname": "Aurora County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46005,
        "countyname": "Beadle County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46007,
        "countyname": "Bennett County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46009,
        "countyname": "Bon Homme County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46011,
        "countyname": "Brookings County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46013,
        "countyname": "Brown County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46015,
        "countyname": "Brule County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46017,
        "countyname": "Buffalo County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46019,
        "countyname": "Butte County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46021,
        "countyname": "Campbell County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46023,
        "countyname": "Charles Mix County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46025,
        "countyname": "Clark County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46027,
        "countyname": "Clay County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46029,
        "countyname": "Codington County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46031,
        "countyname": "Corson County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46033,
        "countyname": "Custer County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46035,
        "countyname": "Davison County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46037,
        "countyname": "Day County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46039,
        "countyname": "Deuel County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46041,
        "countyname": "Dewey County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46043,
        "countyname": "Douglas County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46045,
        "countyname": "Edmunds County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46047,
        "countyname": "Fall River County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46049,
        "countyname": "Faulk County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46051,
        "countyname": "Grant County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46053,
        "countyname": "Gregory County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46055,
        "countyname": "Haakon County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46057,
        "countyname": "Hamlin County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46059,
        "countyname": "Hand County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46061,
        "countyname": "Hanson County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46063,
        "countyname": "Harding County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46065,
        "countyname": "Hughes County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46067,
        "countyname": "Hutchinson County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46069,
        "countyname": "Hyde County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46071,
        "countyname": "Jackson County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46073,
        "countyname": "Jerauld County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46075,
        "countyname": "Jones County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46077,
        "countyname": "Kingsbury County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46079,
        "countyname": "Lake County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46081,
        "countyname": "Lawrence County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46083,
        "countyname": "Lincoln County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46085,
        "countyname": "Lyman County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46087,
        "countyname": "McCook County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46089,
        "countyname": "McPherson County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46091,
        "countyname": "Marshall County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46093,
        "countyname": "Meade County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46095,
        "countyname": "Mellette County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46097,
        "countyname": "Miner County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46099,
        "countyname": "Minnehaha County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46101,
        "countyname": "Moody County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46103,
        "countyname": "Pennington County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46105,
        "countyname": "Perkins County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46107,
        "countyname": "Potter County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46109,
        "countyname": "Roberts County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46111,
        "countyname": "Sanborn County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46113,
        "countyname": "Shannon County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46115,
        "countyname": "Spink County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46117,
        "countyname": "Stanley County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46119,
        "countyname": "Sully County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46121,
        "countyname": "Todd County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46123,
        "countyname": "Tripp County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46125,
        "countyname": "Turner County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46127,
        "countyname": "Union County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46129,
        "countyname": "Walworth County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46135,
        "countyname": "Yankton County",
        "stateorprovince": "SD"
    },
    {
        "fips": 46137,
        "countyname": "Ziebach County",
        "stateorprovince": "SD"
    },
    {
        "fips": 47001,
        "countyname": "Anderson County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47003,
        "countyname": "Bedford County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47005,
        "countyname": "Benton County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47007,
        "countyname": "Bledsoe County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47009,
        "countyname": "Blount County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47011,
        "countyname": "Bradley County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47013,
        "countyname": "Campbell County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47015,
        "countyname": "Cannon County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47017,
        "countyname": "Carroll County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47019,
        "countyname": "Carter County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47021,
        "countyname": "Cheatham County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47023,
        "countyname": "Chester County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47025,
        "countyname": "Claiborne County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47027,
        "countyname": "Clay County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47029,
        "countyname": "Cocke County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47031,
        "countyname": "Coffee County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47033,
        "countyname": "Crockett County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47035,
        "countyname": "Cumberland County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47037,
        "countyname": "Davidson County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47039,
        "countyname": "Decatur County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47041,
        "countyname": "DeKalb County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47043,
        "countyname": "Dickson County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47045,
        "countyname": "Dyer County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47047,
        "countyname": "Fayette County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47049,
        "countyname": "Fentress County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47051,
        "countyname": "Franklin County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47053,
        "countyname": "Gibson County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47055,
        "countyname": "Giles County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47057,
        "countyname": "Grainger County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47059,
        "countyname": "Greene County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47061,
        "countyname": "Grundy County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47063,
        "countyname": "Hamblen County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47065,
        "countyname": "Hamilton County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47067,
        "countyname": "Hancock County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47069,
        "countyname": "Hardeman County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47071,
        "countyname": "Hardin County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47073,
        "countyname": "Hawkins County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47075,
        "countyname": "Haywood County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47077,
        "countyname": "Henderson County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47079,
        "countyname": "Henry County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47081,
        "countyname": "Hickman County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47083,
        "countyname": "Houston County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47085,
        "countyname": "Humphreys County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47087,
        "countyname": "Jackson County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47089,
        "countyname": "Jefferson County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47091,
        "countyname": "Johnson County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47093,
        "countyname": "Knox County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47095,
        "countyname": "Lake County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47097,
        "countyname": "Lauderdale County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47099,
        "countyname": "Lawrence County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47101,
        "countyname": "Lewis County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47103,
        "countyname": "Lincoln County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47105,
        "countyname": "Loudon County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47107,
        "countyname": "McMinn County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47109,
        "countyname": "McNairy County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47111,
        "countyname": "Macon County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47113,
        "countyname": "Madison County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47115,
        "countyname": "Marion County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47117,
        "countyname": "Marshall County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47119,
        "countyname": "Maury County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47121,
        "countyname": "Meigs County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47123,
        "countyname": "Monroe County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47125,
        "countyname": "Montgomery County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47127,
        "countyname": "Moore County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47129,
        "countyname": "Morgan County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47131,
        "countyname": "Obion County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47133,
        "countyname": "Overton County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47135,
        "countyname": "Perry County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47137,
        "countyname": "Pickett County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47139,
        "countyname": "Polk County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47141,
        "countyname": "Putnam County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47143,
        "countyname": "Rhea County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47145,
        "countyname": "Roane County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47147,
        "countyname": "Robertson County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47149,
        "countyname": "Rutherford County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47151,
        "countyname": "Scott County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47153,
        "countyname": "Sequatchie County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47155,
        "countyname": "Sevier County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47157,
        "countyname": "Shelby County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47159,
        "countyname": "Smith County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47161,
        "countyname": "Stewart County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47163,
        "countyname": "Sullivan County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47165,
        "countyname": "Sumner County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47167,
        "countyname": "Tipton County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47169,
        "countyname": "Trousdale County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47171,
        "countyname": "Unicoi County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47173,
        "countyname": "Union County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47175,
        "countyname": "Van Buren County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47177,
        "countyname": "Warren County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47179,
        "countyname": "Washington County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47181,
        "countyname": "Wayne County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47183,
        "countyname": "Weakley County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47185,
        "countyname": "White County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47187,
        "countyname": "Williamson County",
        "stateorprovince": "TN"
    },
    {
        "fips": 47189,
        "countyname": "Wilson County",
        "stateorprovince": "TN"
    },
    {
        "fips": 48001,
        "countyname": "Anderson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48003,
        "countyname": "Andrews County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48005,
        "countyname": "Angelina County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48007,
        "countyname": "Aransas County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48009,
        "countyname": "Archer County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48011,
        "countyname": "Armstrong County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48013,
        "countyname": "Atascosa County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48015,
        "countyname": "Austin County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48017,
        "countyname": "Bailey County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48019,
        "countyname": "Bandera County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48021,
        "countyname": "Bastrop County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48023,
        "countyname": "Baylor County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48025,
        "countyname": "Bee County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48027,
        "countyname": "Bell County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48029,
        "countyname": "Bexar County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48031,
        "countyname": "Blanco County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48033,
        "countyname": "Borden County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48035,
        "countyname": "Bosque County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48037,
        "countyname": "Bowie County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48039,
        "countyname": "Brazoria County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48041,
        "countyname": "Brazos County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48043,
        "countyname": "Brewster County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48045,
        "countyname": "Briscoe County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48047,
        "countyname": "Brooks County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48049,
        "countyname": "Brown County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48051,
        "countyname": "Burleson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48053,
        "countyname": "Burnet County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48055,
        "countyname": "Caldwell County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48057,
        "countyname": "Calhoun County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48059,
        "countyname": "Callahan County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48061,
        "countyname": "Cameron County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48063,
        "countyname": "Camp County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48065,
        "countyname": "Carson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48067,
        "countyname": "Cass County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48069,
        "countyname": "Castro County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48071,
        "countyname": "Chambers County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48073,
        "countyname": "Cherokee County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48075,
        "countyname": "Childress County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48077,
        "countyname": "Clay County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48079,
        "countyname": "Cochran County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48081,
        "countyname": "Coke County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48083,
        "countyname": "Coleman County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48085,
        "countyname": "Collin County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48087,
        "countyname": "Collingsworth County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48089,
        "countyname": "Colorado County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48091,
        "countyname": "Comal County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48093,
        "countyname": "Comanche County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48095,
        "countyname": "Concho County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48097,
        "countyname": "Cooke County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48099,
        "countyname": "Coryell County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48101,
        "countyname": "Cottle County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48103,
        "countyname": "Crane County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48105,
        "countyname": "Crockett County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48107,
        "countyname": "Crosby County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48109,
        "countyname": "Culberson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48111,
        "countyname": "Dallam County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48113,
        "countyname": "Dallas County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48115,
        "countyname": "Dawson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48117,
        "countyname": "Deaf Smith County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48119,
        "countyname": "Delta County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48121,
        "countyname": "Denton County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48123,
        "countyname": "DeWitt County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48125,
        "countyname": "Dickens County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48127,
        "countyname": "Dimmit County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48129,
        "countyname": "Donley County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48131,
        "countyname": "Duval County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48133,
        "countyname": "Eastland County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48135,
        "countyname": "Ector County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48137,
        "countyname": "Edwards County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48139,
        "countyname": "Ellis County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48141,
        "countyname": "El Paso County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48143,
        "countyname": "Erath County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48145,
        "countyname": "Falls County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48147,
        "countyname": "Fannin County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48149,
        "countyname": "Fayette County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48151,
        "countyname": "Fisher County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48153,
        "countyname": "Floyd County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48155,
        "countyname": "Foard County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48157,
        "countyname": "Fort Bend County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48159,
        "countyname": "Franklin County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48161,
        "countyname": "Freestone County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48163,
        "countyname": "Frio County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48165,
        "countyname": "Gaines County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48167,
        "countyname": "Galveston County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48169,
        "countyname": "Garza County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48171,
        "countyname": "Gillespie County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48173,
        "countyname": "Glasscock County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48175,
        "countyname": "Goliad County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48177,
        "countyname": "Gonzales County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48179,
        "countyname": "Gray County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48181,
        "countyname": "Grayson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48183,
        "countyname": "Gregg County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48185,
        "countyname": "Grimes County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48187,
        "countyname": "Guadalupe County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48189,
        "countyname": "Hale County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48191,
        "countyname": "Hall County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48193,
        "countyname": "Hamilton County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48195,
        "countyname": "Hansford County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48197,
        "countyname": "Hardeman County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48199,
        "countyname": "Hardin County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48201,
        "countyname": "Harris County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48203,
        "countyname": "Harrison County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48205,
        "countyname": "Hartley County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48207,
        "countyname": "Haskell County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48209,
        "countyname": "Hays County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48211,
        "countyname": "Hemphill County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48213,
        "countyname": "Henderson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48215,
        "countyname": "Hidalgo County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48217,
        "countyname": "Hill County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48219,
        "countyname": "Hockley County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48221,
        "countyname": "Hood County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48223,
        "countyname": "Hopkins County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48225,
        "countyname": "Houston County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48227,
        "countyname": "Howard County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48229,
        "countyname": "Hudspeth County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48231,
        "countyname": "Hunt County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48233,
        "countyname": "Hutchinson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48235,
        "countyname": "Irion County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48237,
        "countyname": "Jack County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48239,
        "countyname": "Jackson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48241,
        "countyname": "Jasper County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48243,
        "countyname": "Jeff Davis County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48245,
        "countyname": "Jefferson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48247,
        "countyname": "Jim Hogg County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48249,
        "countyname": "Jim Wells County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48251,
        "countyname": "Johnson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48253,
        "countyname": "Jones County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48255,
        "countyname": "Karnes County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48257,
        "countyname": "Kaufman County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48259,
        "countyname": "Kendall County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48261,
        "countyname": "Kenedy County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48263,
        "countyname": "Kent County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48265,
        "countyname": "Kerr County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48267,
        "countyname": "Kimble County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48269,
        "countyname": "King County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48271,
        "countyname": "Kinney County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48273,
        "countyname": "Kleberg County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48275,
        "countyname": "Knox County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48277,
        "countyname": "Lamar County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48279,
        "countyname": "Lamb County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48281,
        "countyname": "Lampasas County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48283,
        "countyname": "La Salle County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48285,
        "countyname": "Lavaca County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48287,
        "countyname": "Lee County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48289,
        "countyname": "Leon County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48291,
        "countyname": "Liberty County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48293,
        "countyname": "Limestone County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48295,
        "countyname": "Lipscomb County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48297,
        "countyname": "Live Oak County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48299,
        "countyname": "Llano County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48301,
        "countyname": "Loving County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48303,
        "countyname": "Lubbock County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48305,
        "countyname": "Lynn County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48307,
        "countyname": "McCulloch County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48309,
        "countyname": "McLennan County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48311,
        "countyname": "McMullen County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48313,
        "countyname": "Madison County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48315,
        "countyname": "Marion County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48317,
        "countyname": "Martin County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48319,
        "countyname": "Mason County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48321,
        "countyname": "Matagorda County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48323,
        "countyname": "Maverick County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48325,
        "countyname": "Medina County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48327,
        "countyname": "Menard County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48329,
        "countyname": "Midland County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48331,
        "countyname": "Milam County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48333,
        "countyname": "Mills County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48335,
        "countyname": "Mitchell County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48337,
        "countyname": "Montague County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48339,
        "countyname": "Montgomery County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48341,
        "countyname": "Moore County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48343,
        "countyname": "Morris County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48345,
        "countyname": "Motley County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48347,
        "countyname": "Nacogdoches County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48349,
        "countyname": "Navarro County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48351,
        "countyname": "Newton County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48353,
        "countyname": "Nolan County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48355,
        "countyname": "Nueces County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48357,
        "countyname": "Ochiltree County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48359,
        "countyname": "Oldham County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48361,
        "countyname": "Orange County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48363,
        "countyname": "Palo Pinto County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48365,
        "countyname": "Panola County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48367,
        "countyname": "Parker County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48369,
        "countyname": "Parmer County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48371,
        "countyname": "Pecos County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48373,
        "countyname": "Polk County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48375,
        "countyname": "Potter County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48377,
        "countyname": "Presidio County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48379,
        "countyname": "Rains County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48381,
        "countyname": "Randall County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48383,
        "countyname": "Reagan County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48385,
        "countyname": "Real County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48387,
        "countyname": "Red River County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48389,
        "countyname": "Reeves County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48391,
        "countyname": "Refugio County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48393,
        "countyname": "Roberts County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48395,
        "countyname": "Robertson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48397,
        "countyname": "Rockwall County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48399,
        "countyname": "Runnels County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48401,
        "countyname": "Rusk County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48403,
        "countyname": "Sabine County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48405,
        "countyname": "San Augustine County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48407,
        "countyname": "San Jacinto County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48409,
        "countyname": "San Patricio County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48411,
        "countyname": "San Saba County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48413,
        "countyname": "Schleicher County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48415,
        "countyname": "Scurry County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48417,
        "countyname": "Shackelford County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48419,
        "countyname": "Shelby County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48421,
        "countyname": "Sherman County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48423,
        "countyname": "Smith County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48425,
        "countyname": "Somervell County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48427,
        "countyname": "Starr County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48429,
        "countyname": "Stephens County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48431,
        "countyname": "Sterling County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48433,
        "countyname": "Stonewall County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48435,
        "countyname": "Sutton County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48437,
        "countyname": "Swisher County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48439,
        "countyname": "Tarrant County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48441,
        "countyname": "Taylor County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48443,
        "countyname": "Terrell County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48445,
        "countyname": "Terry County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48447,
        "countyname": "Throckmorton County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48449,
        "countyname": "Titus County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48451,
        "countyname": "Tom Green County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48453,
        "countyname": "Travis County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48455,
        "countyname": "Trinity County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48457,
        "countyname": "Tyler County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48459,
        "countyname": "Upshur County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48461,
        "countyname": "Upton County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48463,
        "countyname": "Uvalde County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48465,
        "countyname": "Val Verde County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48467,
        "countyname": "Van Zandt County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48469,
        "countyname": "Victoria County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48471,
        "countyname": "Walker County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48473,
        "countyname": "Waller County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48475,
        "countyname": "Ward County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48477,
        "countyname": "Washington County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48479,
        "countyname": "Webb County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48481,
        "countyname": "Wharton County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48483,
        "countyname": "Wheeler County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48485,
        "countyname": "Wichita County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48487,
        "countyname": "Wilbarger County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48489,
        "countyname": "Willacy County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48491,
        "countyname": "Williamson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48493,
        "countyname": "Wilson County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48495,
        "countyname": "Winkler County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48497,
        "countyname": "Wise County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48499,
        "countyname": "Wood County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48501,
        "countyname": "Yoakum County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48503,
        "countyname": "Young County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48505,
        "countyname": "Zapata County",
        "stateorprovince": "TX"
    },
    {
        "fips": 48507,
        "countyname": "Zavala County",
        "stateorprovince": "TX"
    },
    {
        "fips": 49001,
        "countyname": "Beaver County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49003,
        "countyname": "Box Elder County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49005,
        "countyname": "Cache County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49007,
        "countyname": "Carbon County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49009,
        "countyname": "Daggett County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49011,
        "countyname": "Davis County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49013,
        "countyname": "Duchesne County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49015,
        "countyname": "Emery County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49017,
        "countyname": "Garfield County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49019,
        "countyname": "Grand County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49021,
        "countyname": "Iron County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49023,
        "countyname": "Juab County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49025,
        "countyname": "Kane County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49027,
        "countyname": "Millard County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49029,
        "countyname": "Morgan County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49031,
        "countyname": "Piute County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49033,
        "countyname": "Rich County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49035,
        "countyname": "Salt Lake County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49037,
        "countyname": "San Juan County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49039,
        "countyname": "Sanpete County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49041,
        "countyname": "Sevier County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49043,
        "countyname": "Summit County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49045,
        "countyname": "Tooele County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49047,
        "countyname": "Uintah County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49049,
        "countyname": "Utah County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49051,
        "countyname": "Wasatch County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49053,
        "countyname": "Washington County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49055,
        "countyname": "Wayne County",
        "stateorprovince": "UT"
    },
    {
        "fips": 49057,
        "countyname": "Weber County",
        "stateorprovince": "UT"
    },
    {
        "fips": 50001,
        "countyname": "Addison County",
        "stateorprovince": "VT"
    },
    {
        "fips": 50003,
        "countyname": "Bennington County",
        "stateorprovince": "VT"
    },
    {
        "fips": 50005,
        "countyname": "Caledonia County",
        "stateorprovince": "VT"
    },
    {
        "fips": 50007,
        "countyname": "Chittenden County",
        "stateorprovince": "VT"
    },
    {
        "fips": 50009,
        "countyname": "Essex County",
        "stateorprovince": "VT"
    },
    {
        "fips": 50011,
        "countyname": "Franklin County",
        "stateorprovince": "VT"
    },
    {
        "fips": 50013,
        "countyname": "Grand Isle County",
        "stateorprovince": "VT"
    },
    {
        "fips": 50015,
        "countyname": "Lamoille County",
        "stateorprovince": "VT"
    },
    {
        "fips": 50017,
        "countyname": "Orange County",
        "stateorprovince": "VT"
    },
    {
        "fips": 50019,
        "countyname": "Orleans County",
        "stateorprovince": "VT"
    },
    {
        "fips": 50021,
        "countyname": "Rutland County",
        "stateorprovince": "VT"
    },
    {
        "fips": 50023,
        "countyname": "Washington County",
        "stateorprovince": "VT"
    },
    {
        "fips": 50025,
        "countyname": "Windham County",
        "stateorprovince": "VT"
    },
    {
        "fips": 50027,
        "countyname": "Windsor County",
        "stateorprovince": "VT"
    },
    {
        "fips": 51001,
        "countyname": "Accomack County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51003,
        "countyname": "Albemarle County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51005,
        "countyname": "Alleghany County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51007,
        "countyname": "Amelia County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51009,
        "countyname": "Amherst County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51011,
        "countyname": "Appomattox County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51013,
        "countyname": "Arlington County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51015,
        "countyname": "Augusta County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51017,
        "countyname": "Bath County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51019,
        "countyname": "Bedford County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51021,
        "countyname": "Bland County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51023,
        "countyname": "Botetourt County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51025,
        "countyname": "Brunswick County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51027,
        "countyname": "Buchanan County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51029,
        "countyname": "Buckingham County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51031,
        "countyname": "Campbell County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51033,
        "countyname": "Caroline County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51035,
        "countyname": "Carroll County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51036,
        "countyname": "Charles City County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51037,
        "countyname": "Charlotte County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51041,
        "countyname": "Chesterfield County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51043,
        "countyname": "Clarke County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51045,
        "countyname": "Craig County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51047,
        "countyname": "Culpeper County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51049,
        "countyname": "Cumberland County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51051,
        "countyname": "Dickenson County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51053,
        "countyname": "Dinwiddie County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51057,
        "countyname": "Essex County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51059,
        "countyname": "Fairfax County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51061,
        "countyname": "Fauquier County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51063,
        "countyname": "Floyd County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51065,
        "countyname": "Fluvanna County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51067,
        "countyname": "Franklin County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51069,
        "countyname": "Frederick County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51071,
        "countyname": "Giles County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51073,
        "countyname": "Gloucester County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51075,
        "countyname": "Goochland County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51077,
        "countyname": "Grayson County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51079,
        "countyname": "Greene County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51081,
        "countyname": "Greensville County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51083,
        "countyname": "Halifax County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51085,
        "countyname": "Hanover County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51087,
        "countyname": "Henrico County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51089,
        "countyname": "Henry County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51091,
        "countyname": "Highland County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51093,
        "countyname": "Isle of Wight County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51095,
        "countyname": "James City County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51097,
        "countyname": "King and Queen County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51099,
        "countyname": "King George County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51101,
        "countyname": "King William County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51103,
        "countyname": "Lancaster County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51105,
        "countyname": "Lee County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51107,
        "countyname": "Loudoun County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51109,
        "countyname": "Louisa County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51111,
        "countyname": "Lunenburg County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51113,
        "countyname": "Madison County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51115,
        "countyname": "Mathews County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51117,
        "countyname": "Mecklenburg County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51119,
        "countyname": "Middlesex County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51121,
        "countyname": "Montgomery County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51125,
        "countyname": "Nelson County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51127,
        "countyname": "New Kent County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51131,
        "countyname": "Northampton County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51133,
        "countyname": "Northumberland County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51135,
        "countyname": "Nottoway County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51137,
        "countyname": "Orange County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51139,
        "countyname": "Page County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51141,
        "countyname": "Patrick County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51143,
        "countyname": "Pittsylvania County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51145,
        "countyname": "Powhatan County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51147,
        "countyname": "Prince Edward County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51149,
        "countyname": "Prince George County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51153,
        "countyname": "Prince William County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51155,
        "countyname": "Pulaski County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51157,
        "countyname": "Rappahannock County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51159,
        "countyname": "Richmond County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51161,
        "countyname": "Roanoke County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51163,
        "countyname": "Rockbridge County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51165,
        "countyname": "Rockingham County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51167,
        "countyname": "Russell County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51169,
        "countyname": "Scott County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51171,
        "countyname": "Shenandoah County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51173,
        "countyname": "Smyth County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51175,
        "countyname": "Southampton County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51177,
        "countyname": "Spotsylvania County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51179,
        "countyname": "Stafford County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51181,
        "countyname": "Surry County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51183,
        "countyname": "Sussex County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51185,
        "countyname": "Tazewell County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51187,
        "countyname": "Warren County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51191,
        "countyname": "Washington County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51193,
        "countyname": "Westmoreland County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51195,
        "countyname": "Wise County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51197,
        "countyname": "Wythe County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51199,
        "countyname": "York County",
        "stateorprovince": "VA"
    },
    {
        "fips": 51510,
        "countyname": "Alexandria city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51515,
        "countyname": "Bedford city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51520,
        "countyname": "Bristol city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51530,
        "countyname": "Buena Vista city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51540,
        "countyname": "Charlottesville city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51550,
        "countyname": "Chesapeake city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51560,
        "countyname": "Clifton Forge city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51570,
        "countyname": "Colonial Heights city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51580,
        "countyname": "Covington city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51590,
        "countyname": "Danville city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51595,
        "countyname": "Emporia city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51600,
        "countyname": "Fairfax city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51610,
        "countyname": "Falls Church city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51620,
        "countyname": "Franklin city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51630,
        "countyname": "Fredericksburg city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51640,
        "countyname": "Galax city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51650,
        "countyname": "Hampton city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51660,
        "countyname": "Harrisonburg city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51670,
        "countyname": "Hopewell city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51678,
        "countyname": "Lexington city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51680,
        "countyname": "Lynchburg city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51683,
        "countyname": "Manassas city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51685,
        "countyname": "Manassas Park city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51690,
        "countyname": "Martinsville city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51700,
        "countyname": "Newport News city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51710,
        "countyname": "Norfolk city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51720,
        "countyname": "Norton city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51730,
        "countyname": "Petersburg city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51735,
        "countyname": "Poquoson city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51740,
        "countyname": "Portsmouth city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51750,
        "countyname": "Radford city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51760,
        "countyname": "Richmond city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51770,
        "countyname": "Roanoke city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51775,
        "countyname": "Salem city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51790,
        "countyname": "Staunton city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51800,
        "countyname": "Suffolk city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51810,
        "countyname": "Virginia Beach city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51820,
        "countyname": "Waynesboro city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51830,
        "countyname": "Williamsburg city",
        "stateorprovince": "VA"
    },
    {
        "fips": 51840,
        "countyname": "Winchester city",
        "stateorprovince": "VA"
    },
    {
        "fips": 53001,
        "countyname": "Adams County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53003,
        "countyname": "Asotin County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53005,
        "countyname": "Benton County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53007,
        "countyname": "Chelan County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53009,
        "countyname": "Clallam County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53011,
        "countyname": "Clark County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53013,
        "countyname": "Columbia County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53015,
        "countyname": "Cowlitz County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53017,
        "countyname": "Douglas County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53019,
        "countyname": "Ferry County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53021,
        "countyname": "Franklin County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53023,
        "countyname": "Garfield County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53025,
        "countyname": "Grant County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53027,
        "countyname": "Grays Harbor County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53029,
        "countyname": "Island County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53031,
        "countyname": "Jefferson County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53033,
        "countyname": "King County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53035,
        "countyname": "Kitsap County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53037,
        "countyname": "Kittitas County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53039,
        "countyname": "Klickitat County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53041,
        "countyname": "Lewis County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53043,
        "countyname": "Lincoln County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53045,
        "countyname": "Mason County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53047,
        "countyname": "Okanogan County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53049,
        "countyname": "Pacific County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53051,
        "countyname": "Pend Oreille County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53053,
        "countyname": "Pierce County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53055,
        "countyname": "San Juan County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53057,
        "countyname": "Skagit County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53059,
        "countyname": "Skamania County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53061,
        "countyname": "Snohomish County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53063,
        "countyname": "Spokane County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53065,
        "countyname": "Stevens County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53067,
        "countyname": "Thurston County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53069,
        "countyname": "Wahkiakum County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53071,
        "countyname": "Walla Walla County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53073,
        "countyname": "Whatcom County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53075,
        "countyname": "Whitman County",
        "stateorprovince": "WA"
    },
    {
        "fips": 53077,
        "countyname": "Yakima County",
        "stateorprovince": "WA"
    },
    {
        "fips": 54001,
        "countyname": "Barbour County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54003,
        "countyname": "Berkeley County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54005,
        "countyname": "Boone County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54007,
        "countyname": "Braxton County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54009,
        "countyname": "Brooke County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54011,
        "countyname": "Cabell County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54013,
        "countyname": "Calhoun County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54015,
        "countyname": "Clay County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54017,
        "countyname": "Doddridge County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54019,
        "countyname": "Fayette County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54021,
        "countyname": "Gilmer County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54023,
        "countyname": "Grant County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54025,
        "countyname": "Greenbrier County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54027,
        "countyname": "Hampshire County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54029,
        "countyname": "Hancock County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54031,
        "countyname": "Hardy County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54033,
        "countyname": "Harrison County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54035,
        "countyname": "Jackson County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54037,
        "countyname": "Jefferson County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54039,
        "countyname": "Kanawha County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54041,
        "countyname": "Lewis County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54043,
        "countyname": "Lincoln County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54045,
        "countyname": "Logan County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54047,
        "countyname": "McDowell County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54049,
        "countyname": "Marion County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54051,
        "countyname": "Marshall County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54053,
        "countyname": "Mason County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54055,
        "countyname": "Mercer County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54057,
        "countyname": "Mineral County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54059,
        "countyname": "Mingo County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54061,
        "countyname": "Monongalia County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54063,
        "countyname": "Monroe County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54065,
        "countyname": "Morgan County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54067,
        "countyname": "Nicholas County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54069,
        "countyname": "Ohio County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54071,
        "countyname": "Pendleton County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54073,
        "countyname": "Pleasants County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54075,
        "countyname": "Pocahontas County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54077,
        "countyname": "Preston County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54079,
        "countyname": "Putnam County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54081,
        "countyname": "Raleigh County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54083,
        "countyname": "Randolph County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54085,
        "countyname": "Ritchie County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54087,
        "countyname": "Roane County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54089,
        "countyname": "Summers County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54091,
        "countyname": "Taylor County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54093,
        "countyname": "Tucker County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54095,
        "countyname": "Tyler County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54097,
        "countyname": "Upshur County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54099,
        "countyname": "Wayne County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54101,
        "countyname": "Webster County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54103,
        "countyname": "Wetzel County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54105,
        "countyname": "Wirt County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54107,
        "countyname": "Wood County",
        "stateorprovince": "WV"
    },
    {
        "fips": 54109,
        "countyname": "Wyoming County",
        "stateorprovince": "WV"
    },
    {
        "fips": 55001,
        "countyname": "Adams County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55003,
        "countyname": "Ashland County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55005,
        "countyname": "Barron County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55007,
        "countyname": "Bayfield County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55009,
        "countyname": "Brown County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55011,
        "countyname": "Buffalo County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55013,
        "countyname": "Burnett County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55015,
        "countyname": "Calumet County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55017,
        "countyname": "Chippewa County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55019,
        "countyname": "Clark County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55021,
        "countyname": "Columbia County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55023,
        "countyname": "Crawford County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55025,
        "countyname": "Dane County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55027,
        "countyname": "Dodge County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55029,
        "countyname": "Door County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55031,
        "countyname": "Douglas County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55033,
        "countyname": "Dunn County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55035,
        "countyname": "Eau Claire County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55037,
        "countyname": "Florence County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55039,
        "countyname": "Fond du Lac County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55041,
        "countyname": "Forest County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55043,
        "countyname": "Grant County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55045,
        "countyname": "Green County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55047,
        "countyname": "Green Lake County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55049,
        "countyname": "Iowa County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55051,
        "countyname": "Iron County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55053,
        "countyname": "Jackson County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55055,
        "countyname": "Jefferson County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55057,
        "countyname": "Juneau County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55059,
        "countyname": "Kenosha County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55061,
        "countyname": "Kewaunee County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55063,
        "countyname": "La Crosse County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55065,
        "countyname": "Lafayette County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55067,
        "countyname": "Langlade County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55069,
        "countyname": "Lincoln County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55071,
        "countyname": "Manitowoc County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55073,
        "countyname": "Marathon County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55075,
        "countyname": "Marinette County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55077,
        "countyname": "Marquette County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55078,
        "countyname": "Menominee County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55079,
        "countyname": "Milwaukee County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55081,
        "countyname": "Monroe County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55083,
        "countyname": "Oconto County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55085,
        "countyname": "Oneida County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55087,
        "countyname": "Outagamie County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55089,
        "countyname": "Ozaukee County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55091,
        "countyname": "Pepin County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55093,
        "countyname": "Pierce County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55095,
        "countyname": "Polk County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55097,
        "countyname": "Portage County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55099,
        "countyname": "Price County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55101,
        "countyname": "Racine County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55103,
        "countyname": "Richland County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55105,
        "countyname": "Rock County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55107,
        "countyname": "Rusk County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55109,
        "countyname": "St. Croix County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55111,
        "countyname": "Sauk County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55113,
        "countyname": "Sawyer County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55115,
        "countyname": "Shawano County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55117,
        "countyname": "Sheboygan County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55119,
        "countyname": "Taylor County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55121,
        "countyname": "Trempealeau County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55123,
        "countyname": "Vernon County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55125,
        "countyname": "Vilas County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55127,
        "countyname": "Walworth County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55129,
        "countyname": "Washburn County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55131,
        "countyname": "Washington County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55133,
        "countyname": "Waukesha County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55135,
        "countyname": "Waupaca County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55137,
        "countyname": "Waushara County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55139,
        "countyname": "Winnebago County",
        "stateorprovince": "WI"
    },
    {
        "fips": 55141,
        "countyname": "Wood County",
        "stateorprovince": "WI"
    },
    {
        "fips": 56001,
        "countyname": "Albany County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56003,
        "countyname": "Big Horn County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56005,
        "countyname": "Campbell County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56007,
        "countyname": "Carbon County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56009,
        "countyname": "Converse County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56011,
        "countyname": "Crook County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56013,
        "countyname": "Fremont County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56015,
        "countyname": "Goshen County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56017,
        "countyname": "Hot Springs County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56019,
        "countyname": "Johnson County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56021,
        "countyname": "Laramie County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56023,
        "countyname": "Lincoln County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56025,
        "countyname": "Natrona County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56027,
        "countyname": "Niobrara County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56029,
        "countyname": "Park County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56031,
        "countyname": "Platte County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56033,
        "countyname": "Sheridan County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56035,
        "countyname": "Sublette County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56037,
        "countyname": "Sweetwater County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56039,
        "countyname": "Teton County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56041,
        "countyname": "Uinta County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56043,
        "countyname": "Washakie County",
        "stateorprovince": "WY"
    },
    {
        "fips": 56045,
        "countyname": "Weston County",
        "stateorprovince": "WY"
    },
    {
        "fips": 66010,
        "countyname": "Guam",
        "stateorprovince": "GU"
    },
    {
        "fips": 72001,
        "countyname": "Adjuntas Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72003,
        "countyname": "Aguada Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72005,
        "countyname": "Aguadilla Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72007,
        "countyname": "Aguas Buenas Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72009,
        "countyname": "Aibonito Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72011,
        "countyname": "Anasco Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72013,
        "countyname": "Arecibo Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72015,
        "countyname": "Arroyo Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72017,
        "countyname": "Barceloneta Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72019,
        "countyname": "Barranquitas Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72021,
        "countyname": "Bayamon Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72023,
        "countyname": "Cabo Rojo Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72025,
        "countyname": "Caguas Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72027,
        "countyname": "Camuy Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72029,
        "countyname": "Canovanas Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72031,
        "countyname": "Carolina Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72033,
        "countyname": "Catano Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72035,
        "countyname": "Cayey Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72037,
        "countyname": "Ceiba Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72039,
        "countyname": "Ciales Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72041,
        "countyname": "Cidra Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72043,
        "countyname": "Coama Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72045,
        "countyname": "Comerio Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72047,
        "countyname": "Corozal Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72049,
        "countyname": "Culebra Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72051,
        "countyname": "Dorado Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72053,
        "countyname": "Fajardo Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72054,
        "countyname": "Florida Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72055,
        "countyname": "Guanica Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72057,
        "countyname": "Guayama Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72059,
        "countyname": "Guayanilla Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72061,
        "countyname": "Guaynabo Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72063,
        "countyname": "Gurabo Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72065,
        "countyname": "Hatillo Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72067,
        "countyname": "Hormigueros Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72069,
        "countyname": "Humacao Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72071,
        "countyname": "Isabela Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72073,
        "countyname": "Jayuya Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72075,
        "countyname": "Juana Diaz Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72077,
        "countyname": "Juncos Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72079,
        "countyname": "Lajas Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72081,
        "countyname": "Lares Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72083,
        "countyname": "Las Marias Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72085,
        "countyname": "Las Piedras Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72087,
        "countyname": "Loiza Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72089,
        "countyname": "Luquillo Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72091,
        "countyname": "Manati Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72093,
        "countyname": "Maricao Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72095,
        "countyname": "Maunabo Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72097,
        "countyname": "Mayaguez Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72099,
        "countyname": "Moca Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72101,
        "countyname": "Morovis Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72103,
        "countyname": "Naguabo Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72105,
        "countyname": "Naranjito Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72107,
        "countyname": "Orocovis Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72109,
        "countyname": "Patillas Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72111,
        "countyname": "Penuelas Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72113,
        "countyname": "Ponce Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72115,
        "countyname": "Quebradillas Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72117,
        "countyname": "Rincon Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72119,
        "countyname": "Rio Grande Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72121,
        "countyname": "Sabana Grande Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72123,
        "countyname": "Salinas Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72125,
        "countyname": "San German Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72127,
        "countyname": "San Juan Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72129,
        "countyname": "San Lorenzo Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72131,
        "countyname": "San Sebastian Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72133,
        "countyname": "Santa Isabel Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72135,
        "countyname": "Toa Alta Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72137,
        "countyname": "Toa Baja Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72139,
        "countyname": "Trujillo Alto Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72141,
        "countyname": "Utuado Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72143,
        "countyname": "Vega Alta Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72145,
        "countyname": "Vega Baja Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72147,
        "countyname": "Vieques Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72149,
        "countyname": "Villalba Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72151,
        "countyname": "Yabucoa Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 72153,
        "countyname": "Yauco Municipio",
        "stateorprovince": "PR"
    },
    {
        "fips": 78010,
        "countyname": "St. Croix",
        "stateorprovince": "VI"
    },
    {
        "fips": 78020,
        "countyname": "St. John",
        "stateorprovince": "VI"
    },
    {
        "fips": 78030,
        "countyname": "St. Thomas",
        "stateorprovince": "VI"
    },
    {
        "fips": 2105,
        "countyname": "Hoonah-Angoon Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 2195,
        "countyname": "Petersburg Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 2198,
        "countyname": "Prince of Wales-Hyder Census Area",
        "stateorprovince": "AK"
    },
    {
        "fips": 2275,
        "countyname": "Wrangell City and Borough",
        "stateorprovince": "AK"
    },
    {
        "fips": 46102,
        "countyname": "Oglala Lakota County",
        "stateorprovince": "SD"
    },
    {
        "fips": 8014,
        "countyname": "Broomfield County",
        "stateorprovince": "CO"
    },
    {
        "fips": 2068,
        "countyname": "Denali Census Area",
        "stateorprovince": "AK"
    }
];